<template>
  <RouterMain />
</template>

<script>

/* eslint-disable */
/* eslint-disable */
//<p class="error">Servers is on maintenance. ETA 10-16 hours.</p>
//v-model="limitTrade" @change="tradehandler"
import io from 'socket.io-client'
import RouterMain from './components/RouterMain.vue'
import { computed } from 'vue'
import axios from 'axios'
import Web3 from 'web3';
import Scroll from './modules/scroll';
 
const Multicall = require('./modules/web3-multicall');
/* eslint-disable */
//

const TESTPROD = false;
const v = 25;
const VERSION = TESTPROD ? process.env.NODE_ENV === 'production'?0:v:v;
const LoginManager = require('./modules/loginManager');
const states = require('./modules/states');

const quoterWeb3 = require('./modules/quoterWeb3');
let prov = new Web3.providers.HttpProvider('https://bsc-dataseed.binance.org');
let bscProv = new Web3.providers.HttpProvider('https://bsc-dataseed.binance.org');
let baseProv = new Web3.providers.HttpProvider('https://mainnet.base.org');
let bridgeProvBSC = new Web3.providers.HttpProvider('https://alien-lively-model.bsc.quiknode.pro/c8ba8198770630b880fdbcf2ffd1d511a4364d71/');
let bridgeProvETH = new Web3.providers.HttpProvider('https://radial-proportionate-hill.quiknode.pro/0ef094232ee41553dbdb4676f1c83e64a699a53a/');
let multicallBSC = new Multicall({
  chainId: 56,
  provider: bscProv
});

let web3VueBSC = new Web3(bscProv);
let web3VueBridgeBSC = new Web3(bridgeProvBSC);
let web3VueBridgeETH = new Web3(bridgeProvETH);
let web3Vue = new Web3(prov);
let multicall = new Multicall({
  chainId: 56,
  provider: prov
});
const ips = [
  'localhost',
  '192.168.68.100'
];
const ip = ips[0];
const URL = process.env.NODE_ENV === 'production' ? (TESTPROD?'https://testmain.def.cafe:2083':'https://prod-1.def.cafe:2083'):`http://${ip}:2083`;
const ABIS = {
  pancakeswapv2: [{"inputs":[{"internalType":"address","name":"_factory","type":"address"},{"internalType":"address","name":"_WETH","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"WETH","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"},{"internalType":"uint256","name":"amountADesired","type":"uint256"},{"internalType":"uint256","name":"amountBDesired","type":"uint256"},{"internalType":"uint256","name":"amountAMin","type":"uint256"},{"internalType":"uint256","name":"amountBMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"addLiquidity","outputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"amountB","type":"uint256"},{"internalType":"uint256","name":"liquidity","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amountTokenDesired","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"addLiquidityETH","outputs":[{"internalType":"uint256","name":"amountToken","type":"uint256"},{"internalType":"uint256","name":"amountETH","type":"uint256"},{"internalType":"uint256","name":"liquidity","type":"uint256"}],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"factory","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint256","name":"reserveIn","type":"uint256"},{"internalType":"uint256","name":"reserveOut","type":"uint256"}],"name":"getAmountIn","outputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"reserveIn","type":"uint256"},{"internalType":"uint256","name":"reserveOut","type":"uint256"}],"name":"getAmountOut","outputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"}],"name":"getAmountsIn","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"}],"name":"getAmountsOut","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"reserveA","type":"uint256"},{"internalType":"uint256","name":"reserveB","type":"uint256"}],"name":"quote","outputs":[{"internalType":"uint256","name":"amountB","type":"uint256"}],"stateMutability":"pure","type":"function"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountAMin","type":"uint256"},{"internalType":"uint256","name":"amountBMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"removeLiquidity","outputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"amountB","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"removeLiquidityETH","outputs":[{"internalType":"uint256","name":"amountToken","type":"uint256"},{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"removeLiquidityETHSupportingFeeOnTransferTokens","outputs":[{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"bool","name":"approveMax","type":"bool"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"removeLiquidityETHWithPermit","outputs":[{"internalType":"uint256","name":"amountToken","type":"uint256"},{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountTokenMin","type":"uint256"},{"internalType":"uint256","name":"amountETHMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"bool","name":"approveMax","type":"bool"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"removeLiquidityETHWithPermitSupportingFeeOnTransferTokens","outputs":[{"internalType":"uint256","name":"amountETH","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"},{"internalType":"uint256","name":"liquidity","type":"uint256"},{"internalType":"uint256","name":"amountAMin","type":"uint256"},{"internalType":"uint256","name":"amountBMin","type":"uint256"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"bool","name":"approveMax","type":"bool"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"removeLiquidityWithPermit","outputs":[{"internalType":"uint256","name":"amountA","type":"uint256"},{"internalType":"uint256","name":"amountB","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapETHForExactTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactETHForTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactETHForTokensSupportingFeeOnTransferTokens","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForETH","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForETHSupportingFeeOnTransferTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapExactTokensForTokensSupportingFeeOnTransferTokens","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint256","name":"amountInMax","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapTokensForExactETH","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint256","name":"amountInMax","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"},{"internalType":"uint256","name":"deadline","type":"uint256"}],"name":"swapTokensForExactTokens","outputs":[{"internalType":"uint256[]","name":"amounts","type":"uint256[]"}],"stateMutability":"nonpayable","type":"function"},{"stateMutability":"payable","type":"receive"}],
  pancakeswapv2Factory: [{"inputs":[{"internalType":"address","name":"_feeToSetter","type":"address"}],"payable":false,"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"token0","type":"address"},{"indexed":true,"internalType":"address","name":"token1","type":"address"},{"indexed":false,"internalType":"address","name":"pair","type":"address"},{"indexed":false,"internalType":"uint256","name":"","type":"uint256"}],"name":"PairCreated","type":"event"},{"constant":true,"inputs":[],"name":"INIT_CODE_PAIR_HASH","outputs":[{"internalType":"bytes32","name":"","type":"bytes32"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"allPairs","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"allPairsLength","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"}],"name":"createPair","outputs":[{"internalType":"address","name":"pair","type":"address"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"feeTo","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"feeToSetter","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"}],"name":"getPair","outputs":[{"internalType":"address","name":"","type":"address"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_feeTo","type":"address"}],"name":"setFeeTo","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":false,"inputs":[{"internalType":"address","name":"_feeToSetter","type":"address"}],"name":"setFeeToSetter","outputs":[],"payable":false,"stateMutability":"nonpayable","type":"function"}],
  ERC20: [{"constant":true,"inputs":[],"name":"name","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_spender","type":"address"},{"name":"_value","type":"uint256"}],"name":"approve","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"totalSupply","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_from","type":"address"},{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transferFrom","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[],"name":"decimals","outputs":[{"name":"","type":"uint8"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"}],"name":"balanceOf","outputs":[{"name":"balance","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":true,"inputs":[],"name":"symbol","outputs":[{"name":"","type":"string"}],"payable":false,"stateMutability":"view","type":"function"},{"constant":false,"inputs":[{"name":"_to","type":"address"},{"name":"_value","type":"uint256"}],"name":"transfer","outputs":[{"name":"","type":"bool"}],"payable":false,"stateMutability":"nonpayable","type":"function"},{"constant":true,"inputs":[{"name":"_owner","type":"address"},{"name":"_spender","type":"address"}],"name":"allowance","outputs":[{"name":"","type":"uint256"}],"payable":false,"stateMutability":"view","type":"function"},{"payable":true,"stateMutability":"payable","type":"fallback"},{"anonymous":false,"inputs":[{"indexed":true,"name":"owner","type":"address"},{"indexed":true,"name":"spender","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Approval","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"name":"from","type":"address"},{"indexed":true,"name":"to","type":"address"},{"indexed":false,"name":"value","type":"uint256"}],"name":"Transfer","type":"event"}],
  uniswapV3Quoter:[{"inputs":[{"internalType":"address","name":"_factory","type":"address"},{"internalType":"address","name":"_WETH9","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"WETH9","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"factory","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes","name":"path","type":"bytes"},{"internalType":"uint256","name":"amountIn","type":"uint256"}],"name":"quoteExactInput","outputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"tokenIn","type":"address"},{"internalType":"address","name":"tokenOut","type":"address"},{"internalType":"uint24","name":"fee","type":"uint24"},{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint160","name":"sqrtPriceLimitX96","type":"uint160"}],"name":"quoteExactInputSingle","outputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"bytes","name":"path","type":"bytes"},{"internalType":"uint256","name":"amountOut","type":"uint256"}],"name":"quoteExactOutput","outputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"address","name":"tokenIn","type":"address"},{"internalType":"address","name":"tokenOut","type":"address"},{"internalType":"uint24","name":"fee","type":"uint24"},{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint160","name":"sqrtPriceLimitX96","type":"uint160"}],"name":"quoteExactOutputSingle","outputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"int256","name":"amount0Delta","type":"int256"},{"internalType":"int256","name":"amount1Delta","type":"int256"},{"internalType":"bytes","name":"path","type":"bytes"}],"name":"uniswapV3SwapCallback","outputs":[],"stateMutability":"view","type":"function"}],
  uniswapV3Router:[{"inputs":[{"internalType":"address","name":"_factoryV2","type":"address"},{"internalType":"address","name":"factoryV3","type":"address"},{"internalType":"address","name":"_positionManager","type":"address"},{"internalType":"address","name":"_WETH9","type":"address"}],"stateMutability":"nonpayable","type":"constructor"},{"inputs":[],"name":"WETH9","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"}],"name":"approveMax","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"}],"name":"approveMaxMinusOne","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"}],"name":"approveZeroThenMax","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"}],"name":"approveZeroThenMaxMinusOne","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"bytes","name":"data","type":"bytes"}],"name":"callPositionManager","outputs":[{"internalType":"bytes","name":"result","type":"bytes"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"bytes[]","name":"paths","type":"bytes[]"},{"internalType":"uint128[]","name":"amounts","type":"uint128[]"},{"internalType":"uint24","name":"maximumTickDivergence","type":"uint24"},{"internalType":"uint32","name":"secondsAgo","type":"uint32"}],"name":"checkOracleSlippage","outputs":[],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"bytes","name":"path","type":"bytes"},{"internalType":"uint24","name":"maximumTickDivergence","type":"uint24"},{"internalType":"uint32","name":"secondsAgo","type":"uint32"}],"name":"checkOracleSlippage","outputs":[],"stateMutability":"view","type":"function"},{"inputs":[{"components":[{"internalType":"bytes","name":"path","type":"bytes"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMinimum","type":"uint256"}],"internalType":"struct IV3SwapRouter.ExactInputParams","name":"params","type":"tuple"}],"name":"exactInput","outputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"}],"stateMutability":"payable","type":"function"},{"inputs":[{"components":[{"internalType":"address","name":"tokenIn","type":"address"},{"internalType":"address","name":"tokenOut","type":"address"},{"internalType":"uint24","name":"fee","type":"uint24"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMinimum","type":"uint256"},{"internalType":"uint160","name":"sqrtPriceLimitX96","type":"uint160"}],"internalType":"struct IV3SwapRouter.ExactInputSingleParams","name":"params","type":"tuple"}],"name":"exactInputSingle","outputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"}],"stateMutability":"payable","type":"function"},{"inputs":[{"components":[{"internalType":"bytes","name":"path","type":"bytes"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint256","name":"amountInMaximum","type":"uint256"}],"internalType":"struct IV3SwapRouter.ExactOutputParams","name":"params","type":"tuple"}],"name":"exactOutput","outputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"}],"stateMutability":"payable","type":"function"},{"inputs":[{"components":[{"internalType":"address","name":"tokenIn","type":"address"},{"internalType":"address","name":"tokenOut","type":"address"},{"internalType":"uint24","name":"fee","type":"uint24"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint256","name":"amountInMaximum","type":"uint256"},{"internalType":"uint160","name":"sqrtPriceLimitX96","type":"uint160"}],"internalType":"struct IV3SwapRouter.ExactOutputSingleParams","name":"params","type":"tuple"}],"name":"exactOutputSingle","outputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"}],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"factory","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"factoryV2","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amount","type":"uint256"}],"name":"getApprovalType","outputs":[{"internalType":"enum IApproveAndCall.ApprovalType","name":"","type":"uint8"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"components":[{"internalType":"address","name":"token0","type":"address"},{"internalType":"address","name":"token1","type":"address"},{"internalType":"uint256","name":"tokenId","type":"uint256"},{"internalType":"uint256","name":"amount0Min","type":"uint256"},{"internalType":"uint256","name":"amount1Min","type":"uint256"}],"internalType":"struct IApproveAndCall.IncreaseLiquidityParams","name":"params","type":"tuple"}],"name":"increaseLiquidity","outputs":[{"internalType":"bytes","name":"result","type":"bytes"}],"stateMutability":"payable","type":"function"},{"inputs":[{"components":[{"internalType":"address","name":"token0","type":"address"},{"internalType":"address","name":"token1","type":"address"},{"internalType":"uint24","name":"fee","type":"uint24"},{"internalType":"int24","name":"tickLower","type":"int24"},{"internalType":"int24","name":"tickUpper","type":"int24"},{"internalType":"uint256","name":"amount0Min","type":"uint256"},{"internalType":"uint256","name":"amount1Min","type":"uint256"},{"internalType":"address","name":"recipient","type":"address"}],"internalType":"struct IApproveAndCall.MintParams","name":"params","type":"tuple"}],"name":"mint","outputs":[{"internalType":"bytes","name":"result","type":"bytes"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"bytes32","name":"previousBlockhash","type":"bytes32"},{"internalType":"bytes[]","name":"data","type":"bytes[]"}],"name":"multicall","outputs":[{"internalType":"bytes[]","name":"","type":"bytes[]"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"bytes[]","name":"data","type":"bytes[]"}],"name":"multicall","outputs":[{"internalType":"bytes[]","name":"","type":"bytes[]"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"bytes[]","name":"data","type":"bytes[]"}],"name":"multicall","outputs":[{"internalType":"bytes[]","name":"results","type":"bytes[]"}],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"positionManager","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"}],"name":"pull","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"refundETH","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"selfPermit","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"nonce","type":"uint256"},{"internalType":"uint256","name":"expiry","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"selfPermitAllowed","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"nonce","type":"uint256"},{"internalType":"uint256","name":"expiry","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"selfPermitAllowedIfNecessary","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"value","type":"uint256"},{"internalType":"uint256","name":"deadline","type":"uint256"},{"internalType":"uint8","name":"v","type":"uint8"},{"internalType":"bytes32","name":"r","type":"bytes32"},{"internalType":"bytes32","name":"s","type":"bytes32"}],"name":"selfPermitIfNecessary","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"},{"internalType":"uint256","name":"amountOutMin","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"}],"name":"swapExactTokensForTokens","outputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountOut","type":"uint256"},{"internalType":"uint256","name":"amountInMax","type":"uint256"},{"internalType":"address[]","name":"path","type":"address[]"},{"internalType":"address","name":"to","type":"address"}],"name":"swapTokensForExactTokens","outputs":[{"internalType":"uint256","name":"amountIn","type":"uint256"}],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amountMinimum","type":"uint256"},{"internalType":"address","name":"recipient","type":"address"}],"name":"sweepToken","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amountMinimum","type":"uint256"}],"name":"sweepToken","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amountMinimum","type":"uint256"},{"internalType":"uint256","name":"feeBips","type":"uint256"},{"internalType":"address","name":"feeRecipient","type":"address"}],"name":"sweepTokenWithFee","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"address","name":"token","type":"address"},{"internalType":"uint256","name":"amountMinimum","type":"uint256"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"feeBips","type":"uint256"},{"internalType":"address","name":"feeRecipient","type":"address"}],"name":"sweepTokenWithFee","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"int256","name":"amount0Delta","type":"int256"},{"internalType":"int256","name":"amount1Delta","type":"int256"},{"internalType":"bytes","name":"_data","type":"bytes"}],"name":"uniswapV3SwapCallback","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountMinimum","type":"uint256"},{"internalType":"address","name":"recipient","type":"address"}],"name":"unwrapWETH9","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountMinimum","type":"uint256"}],"name":"unwrapWETH9","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountMinimum","type":"uint256"},{"internalType":"address","name":"recipient","type":"address"},{"internalType":"uint256","name":"feeBips","type":"uint256"},{"internalType":"address","name":"feeRecipient","type":"address"}],"name":"unwrapWETH9WithFee","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"amountMinimum","type":"uint256"},{"internalType":"uint256","name":"feeBips","type":"uint256"},{"internalType":"address","name":"feeRecipient","type":"address"}],"name":"unwrapWETH9WithFee","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[{"internalType":"uint256","name":"value","type":"uint256"}],"name":"wrapETH","outputs":[],"stateMutability":"payable","type":"function"},{"stateMutability":"payable","type":"receive"}],
  uniswapV3Factory:[{"inputs":[],"stateMutability":"nonpayable","type":"constructor"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"uint24","name":"fee","type":"uint24"},{"indexed":true,"internalType":"int24","name":"tickSpacing","type":"int24"}],"name":"FeeAmountEnabled","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"oldOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnerChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"token0","type":"address"},{"indexed":true,"internalType":"address","name":"token1","type":"address"},{"indexed":true,"internalType":"uint24","name":"fee","type":"uint24"},{"indexed":false,"internalType":"int24","name":"tickSpacing","type":"int24"},{"indexed":false,"internalType":"address","name":"pool","type":"address"}],"name":"PoolCreated","type":"event"},{"inputs":[{"internalType":"address","name":"tokenA","type":"address"},{"internalType":"address","name":"tokenB","type":"address"},{"internalType":"uint24","name":"fee","type":"uint24"}],"name":"createPool","outputs":[{"internalType":"address","name":"pool","type":"address"}],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint24","name":"fee","type":"uint24"},{"internalType":"int24","name":"tickSpacing","type":"int24"}],"name":"enableFeeAmount","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[{"internalType":"uint24","name":"","type":"uint24"}],"name":"feeAmountTickSpacing","outputs":[{"internalType":"int24","name":"","type":"int24"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"},{"internalType":"address","name":"","type":"address"},{"internalType":"uint24","name":"","type":"uint24"}],"name":"getPool","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"owner","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"parameters","outputs":[{"internalType":"address","name":"factory","type":"address"},{"internalType":"address","name":"token0","type":"address"},{"internalType":"address","name":"token1","type":"address"},{"internalType":"uint24","name":"fee","type":"uint24"},{"internalType":"int24","name":"tickSpacing","type":"int24"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"_owner","type":"address"}],"name":"setOwner","outputs":[],"stateMutability":"nonpayable","type":"function"}],  
  staking:[{"anonymous":false,"inputs":[{"indexed":false,"internalType":"uint8","name":"version","type":"uint8"}],"name":"Initialized","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"chainId","type":"uint256"}],"name":"LogChainChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"LogCompoundBuy","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"bytes32","name":"transactionHash","type":"bytes32"},{"indexed":false,"internalType":"uint32","name":"chainId","type":"uint32"}],"name":"LogDeposit","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"address","name":"token","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"LogERC20Recovered","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"}],"name":"LogETHRecovered","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"address","name":"signer","type":"address"}],"name":"LogSignerChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"uint32","name":"chainId","type":"uint32"}],"name":"LogStake","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"address","name":"token","type":"address"}],"name":"LogTokenInterfaceChanged","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"uint32","name":"chainId","type":"uint32"}],"name":"LogUnstake","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"user","type":"address"},{"indexed":false,"internalType":"uint256","name":"amount","type":"uint256"},{"indexed":false,"internalType":"bytes32","name":"transactionHash","type":"bytes32"},{"indexed":false,"internalType":"uint32","name":"chainId","type":"uint32"}],"name":"LogWithdraw","type":"event"},{"anonymous":false,"inputs":[{"indexed":true,"internalType":"address","name":"previousOwner","type":"address"},{"indexed":true,"internalType":"address","name":"newOwner","type":"address"}],"name":"OwnershipTransferred","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Paused","type":"event"},{"anonymous":false,"inputs":[{"indexed":false,"internalType":"address","name":"account","type":"address"}],"name":"Unpaused","type":"event"},{"inputs":[],"name":"compoundBuy","outputs":[],"stateMutability":"payable","type":"function"},{"inputs":[],"name":"getReserves","outputs":[{"internalType":"uint256","name":"","type":"uint256"}],"stateMutability":"view","type":"function"},{"inputs":[],"name":"paused","outputs":[{"internalType":"bool","name":"","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"address","name":"","type":"address"}],"name":"poolInfo","outputs":[{"internalType":"uint256","name":"amount","type":"uint256"},{"internalType":"bool","name":"inPool","type":"bool"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"","type":"uint256"}],"name":"poolUsers","outputs":[{"internalType":"address","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"stake","outputs":[],"stateMutability":"nonpayable","type":"function"},{"inputs":[],"name":"uniswapV2Router","outputs":[{"internalType":"contract IUniswapV2Router02","name":"","type":"address"}],"stateMutability":"view","type":"function"},{"inputs":[{"internalType":"uint256","name":"_amount","type":"uint256"}],"name":"unstake","outputs":[],"stateMutability":"nonpayable","type":"function"}]
}
let stakingContractBSC;
let stakingContractETH;
let cafeContractBSC;
let cafeContractETH;

const CAFE = "0xdefCafE7eAC90d31BbBA841038DF365DE3c4e207";
const CAFEETH = "0xdefCafE7eAC90d31BbBA841038DF365DE3c4e207";
const STAKING = "0xEda824065af6cF8366E1BF9156a8f4a5C40aC389";
const STAKINGETH = "0xeD12CDD171F8d315bDe84918E9f58f62BfCA8c1a";
let pcsContractVue;
let quoterContract;
let tokenContract;
let WETHcontract;

const VALUECHECK = /^[0-9.]*$/;
function isLocalStorage() {
      var test = 'test';
      try {
          localStorage.setItem(test, test);
          localStorage.removeItem(test);
          return true;
      } catch(e) {
          return false;
      }
    }
export default {
  name: 'App',
  components: {
    RouterMain
  },
  data () {
    return {
      cafe: {
        BSC: 0,
        ETH: 0,
        BSCWALLET: 0,
        ETHWALLET: 0
      },
      prevSearch: '',
      newSearch: '',
      searchInProgress: false,
      referralData: null,
      windowHeight: window.innerHeight,
      botOn: false,
      address: process.env.NODE_ENV === 'production' ?'':'0x75c97384ca209f915381755c582ec0e2ce88c1ba',
      amount: 0.0,
      sellamount: 0.0,
      key: '',
      gas: 3,
      gasPreset: 'medium',
      logs: true,
      socket: io(URL,{autoConnect:false,
      reconnection: true,
      withCredentials: true,
      }),
      withdrawalsArray: [],
      logsArray: [],
      logsClassArray: ['standard','warning','warning','error'],
      logsClassConvertionToColor: {
        standard: 'default',
        warning: 'dark',
        error:'red'
      },
      logsClass: [],
      authWallet: null,
      logsTxHasArray: [],
      block: 0,
      importWalletShow: false,
      showWalletWarning: false,
      walletWarningMessage: '',
      walletsArray : [],
      deletedWalletsExists : false,
      defaultButtonWalletClass: 'backLogs walletSpanUse button-buy-console margin-zero-top',
      defaultButtonWalletImportClass: 'backLogs backLogsMargin button-buy-console margin-zero-top',
      activeWalletClass: 'backLogButtonActive',
      defaultTrashClass: 'far fa-trash-alt trashIcon',
      activeTrashClass: 'fas fa-arrow-left trashIcon',
      showTrash: true,
      inputImportKey : '',
      walletWarningTimeout : null,
      blockWarningTimeout : null,
      reRender: 0,
      reRenderUse: 0,
      classMarginLeft : 'DisableLeftMargin',
      classBLLaunches: 'backLogsLaunches',
      blockWarningMessage: '',
      currentScreen: 'chart',
      walletForDeletion: null,
      maintenance: false,
      currentWallet: null,
      currentToken: null,
      resultArray: [],
      ordersArray: [],
      tSL: false,
      balUpdateTimeout: null,
      showOrdersHistory: true,
      showMarketOrders: false,
      autoTrades: {},
      marketTrades: {},
      isPanelBuyingNow: true,
      buyPercentage: 0,
      useSL: false,
      usrReRenderer: 0,
      useTP: false,
      useBP: false,
      stopLoss: 0,
      takeProfit: 0,
      currentValues: [0,0,0,0,0,0],
      favorites: {},
      quickWarn: null,
      quickWarnTimeout: null,
      connected: false,
      botSwapFocus: false,
      settingsJSMounted: false,
      scrollScriptSettings: null,
      settingsGas: 200,
      settingsSlippage: 1,
      txCost: 0,
      minBalToSend: 0,
      approved: false,
      providerConnect: false,
      bridgeToETH: true,
      reRenderBridge: 0,
      chain: {
        ID: 56,
        symbol: 'BNB',
        RPC: 'https://bsc-dataseed.binance.org',
        explorer: 'https://bscscan.com/',
        icon: 'bnb.png',
        baseGas: 1,
        WETH:'0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c',
        swaps: {
            PancakeSwapV2: {
                name: 'PancakeSwap',
                address: '0x10ED43C718714eb63d5aA57B78B54704E256024E',
                factory: '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73',
                ABI: "pancakeswapv2",
                ABIFactory: "pancakeswapv2Factory",
                icon: 'pancakeswap.png',
                default: true
            }
        },
        settings: {
            trading: true,
            limitOrders: true,
            frontrun: true, 
            sniping: false
        },
        pairs: ['0xe9e7cea3dedca5984780bafc599bd69add087d56',
        '0x52ce071bd9b1c4b00a0b92d298c512478cad67e8',
        '0x26a5dfab467d4f58fb266648cae769503cec9580',
        '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d',
        '0x55d398326f99059ff775485246999027b3197955',
        '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c',
        '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c',
        '0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3',
        '0x2170ed0880ac9a755fd29b2688956bd959f933f8'],
        pairsTagsLocale: {
            '0xe9e7cea3dedca5984780bafc599bd69add087d56':"BUSD",
            '0x8ac76a51cc950d9822d68b83fe1ad97b32cd580d':"USDC",
            '0x55d398326f99059ff775485246999027b3197955':"USDT",
            '0x1af3f329e8be154074d8769d1ffa4ee058b1dbc3':"DAI"
            },
        pairsTags:{
            '0xbb4cdb9cbd36b01bd1cbaebf2de08d9173bc095c':"WBNB",
            '0x7130d2a12b9bcbfae4f2634d864a1ee1ce3ead9c':"BTCB",
            '0x2170ed0880ac9a755fd29b2688956bd959f933f8':"ETH"
            },
        USDAddress:"0xe9e7CEA3DedcA5984780Bafc599bD69ADd087D56"
      },
      currentSwap: {
        name: 'PancakeSwap',
        address: '0x10ED43C718714eb63d5aA57B78B54704E256024E',
        factory: '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73',
        ABI: "pancakeswapv2",
        ABIFactory: "pancakeswapv2Factory",
        icon: 'pancakeswap.png',
        default: true
      },
      reRenderChart: 0,
      atRerenderer: 0,
      mtRerenderer: 0,
      currentWalletOptions: 0,
      secretWallets: null,
      swPage: null,
      secretWalletSelected: null,
      hPage: null,
      currentRename: -1,
      renameValue: "",
      baseWithdrawValue: 0,
      priceTriggerAmount: 0,
      buyingPriceMultiplyer: 1,
      USDPrice: 0,
      WETHPrice: 0,
      renameKey: 0,
      MCAP: 0,
      refEarnings: 0,
      LP: 0,
      root: null,
      dark: true,
      svgBG: [],
      svgCC: [],
      svgBORD: [],
      styleChanged: 0,
      currentBlockData: {
        block: 0,
        timestamp: 0,
        gas: null,
        balances: [],
        allowance: -1
      },
      settingsActive: false,
      freeUpgradeAvailable: false,
      prevChain:56,
      useMEV: true,
      disableRetry: false,
      exportedKey: null,
      profileActive: false,
      user: null,
      ignoreSearchHandler: false,
      helpActive: false,
      eligibleData: null,
      showActiveSnipes: true,
      }
  },
  provide () {
    return {
      setLimitOrderRetry: computed(() => this.setLimitOrderRetry),
      getWalletAddressOrTag: computed(() => this.getWalletAddressOrTag),
      searchInProgress: computed(() => this.searchInProgress),
      withdrawalsArray: computed(() => this.withdrawalsArray),
      hideHelpPopup: computed(() => this.hideHelpPopup),
      helpActive: computed(() => this.helpActive),
      showHelpPopup: computed(() => this.showHelpPopup),
      pasteToSearchbar: computed(() => this.pasteToSearchbar),
      copyRefLink: computed(() => this.copyRefLink),
      refEarnings: computed(() => this.refEarnings),
      referralData: computed(() => this.referralData),
      upgradeTier: computed(() => this.upgradeTier),
      renameKey: computed(() => this.renameKey),
      bridge: computed(() => this.bridge),
      usrReRenderer: computed(() => this.usrReRenderer),
      subscribe: computed(() => this.subscribe),
      cafe: computed(() => this.cafe),
      botOn: computed(() => this.botOn),
      user: computed(() => this.user),
      freeUpgradeAvailable: computed(() => this.freeUpgradeAvailable),
      address: computed(() => this.address),
      amount: computed(() => this.amount),
      sellamount: computed(() => this.sellamount),
      key: computed(() => this.key),
      gas: computed(() => this.gas),
      logs: computed(() => this.logs),
      socket: computed(() => this.socket),
      logsArray: computed(() => this.logsArray),
      bridgeToETH: computed(() => this.bridgeToETH),
      switchBridgeDestination: computed(() => this.switchBridgeDestination),
      logsClassArray: computed(() => this.logsClassArray),
      logsClassConvertionToColor:computed(() => this.logsClassConvertionToColor),
      logsClass: computed(() => this.logsClass),
      logsTxHasArray: computed(() => this.logsTxHasArray),
      block: computed(() => this.block),
      importWalletShow: computed(() => this.importWalletShow),
      showWalletWarning: computed(() => this.showWalletWarning),
      walletWarningMessage: computed(() => this.walletWarningMessage),
      walletsArray: computed(() => this.walletsArray),
      deletedWalletsExists : computed(() => this.deletedWalletsExists),
      defaultButtonWalletClass: computed(() => this.defaultButtonWalletClass),
      defaultButtonWalletImportClass: computed(() => this.defaultButtonWalletImportClass),
      activeWalletClass: computed(() => this.activeWalletClass),
      defaultTrashClass: computed(() => this.defaultTrashClass),
      activeTrashClass: computed(() => this.activeTrashClass),
      showTrash: computed(() => this.showTrash),
      inputImportKey : computed(() => this.inputImportKey),
      walletWarningTimeout : computed(() => this.walletWarningTimeout),
      blockWarningTimeout : computed(() => this.blockWarningTimeout),
      reRender: computed(() => this.reRender),
      reRenderUse: computed(() => this.reRenderUse),
      classMarginLeft : computed(() => this.classMarginLeft),
      classBLLaunches: computed(() => this.classBLLaunches),
      blockWarningMessage: computed(() => this.blockWarningMessage),
      currentScreen: computed(() => this.currentScreen),
      walletForDeletion: computed(() => this.walletForDeletion),
      maintenance: computed(() => this.maintenance),
      currentWallet: computed(() => this.currentWallet),
      currentToken: computed(() => this.currentToken),
      resultArray: computed(() => this.resultArray),
      ordersArray: computed(() => this.ordersArray),
      tSL: computed(() => this.tSL),
      balUpdateTimeout: computed(() => this.balUpdateTimeout),
      showOrdersHistory: computed(() => this.showOrdersHistory),
      showMarketOrders: computed(() => this.showMarketOrders),
      autoTrades: computed(() => this.autoTrades),
      marketTrades: computed(() => this.marketTrades),
      isPanelBuyingNow: computed(() => this.isPanelBuyingNow),
      buyPercentage: computed(() => this.buyPercentage),
      useSL: computed(() => this.useSL),
      useTP: computed(() => this.useTP),
      useBP: computed(() => this.useBP),
      stopLoss: computed(() => this.stopLoss),
      takeProfit: computed(() => this.takeProfit),
      currentValues: computed(() => this.currentValues),
      favorites: computed(() => this.favorites),
      quickWarn: computed(() => this.quickWarn),
      quickWarnTimeout: computed(() => this.quickWarnTimeout),
      connected: computed(() => this.connected),
      botSwapFocus: computed(() => this.botSwapFocus),
      settingsJSMounted: computed(() => this.settingsJSMounted),
      scrollScriptSettings: computed(() => this.scrollScriptSettings),
      settingsGas: computed(() => this.settingsGas),
      settingsSlippage: computed(() => this.settingsSlippage),
      txCost: computed(() => this.txCost),
      approved: computed(() => this.approved),
      chain: computed(() => this.chain),
      currentSwap: computed(() => this.currentSwap),
      reRenderChart: computed(() => this.reRenderChart),
      atRerenderer: computed(() => this.atRerenderer),
      mtRerenderer: computed(() => this.mtRerenderer),
      currentWalletOptions: computed(() => this.currentWalletOptions),
      secretWallets: computed(() => this.secretWallets),
      swPage: computed(() => this.swPage),
      secretWalletSelected: computed(() => this.secretWalletSelected),
      hPage: computed(() => this.hPage),
      currentRename: computed(() => this.currentRename),
      renameValue: computed(() => this.renameValue),
      baseWithdrawValue: computed(() => this.baseWithdrawValue),
      priceTriggerAmount: computed(() => this.priceTriggerAmount),
      buyingPriceMultiplyer: computed(() => this.buyingPriceMultiplyer),
      USDPrice: computed(() => this.USDPrice),
      WETHPrice: computed(() => this.WETHPrice),
      MCAP: computed(() => this.MCAP),
      LP: computed(() => this.LP),
      root: computed(() => this.root),
      dark: computed(() => this.dark),
      svgBG: computed(() => this.svgBG),
      svgCC: computed(() => this.svgCC),
      svgBORD: computed(() => this.svgBORD),
      disableRetry: computed(() => this.disableRetry),
      changeDisableRetry: computed(() => this.changeDisableRetry),
      styleChanged: computed(() => this.styleChanged),
      currentBlockData: computed(() => this.currentBlockData),
      settingsActive: computed(() => this.settingsActive),
      providerConnect: computed(() => this.providerConnect),
      gasPreset: computed(() => this.gasPreset),
      minBalToSend: computed(() => this.minBalToSend),
      setLimitOrderProtectons: computed(() => this.setLimitOrderProtectons),
      setLimits:  computed(() => this.setLimits),
      toUpperCase: computed(() => this.toUpperCase),
      tokenInFavoritesUsed: computed(() => this.tokenInFavoritesUsed),
      search: computed(() => this.search),
      eligibleData: computed(() => this.eligibleData),
      clearSearch: computed(() => this.clearSearch),
      addToFavorites: computed(() => this.addToFavorites),
      isBNB: computed(() => this.isBNB),
      showLogSection: computed(() => this.showLogSection),
      switchLogSection: computed(() => this.switchLogSection),
      useDirectPairOnStable: computed(() => this.useDirectPairOnStable),
      deleteWallet: computed(() => this.deleteWallet),
      cancelDeleteWallet: computed(() => this.cancelDeleteWallet),
      createWallet: computed(() => this.createWallet),
      showImportField: computed(() => this.showImportField),
      switchWalletView: computed(() => this.switchWalletView),
      importWallet: computed(() => this.importWallet),
      updateWalletUse: computed(() => this.updateWalletUse),
      showEmpty: computed(() => this.showEmpty),
      showWalletRow: computed(() => this.showWalletRow),
      renameActive: computed(() => this.renameActive),
      copyAddress: computed(() => this.copyAddress),
      hideRename: computed(() => this.hideRename),
      showOptionsPopUp: computed(() => this.showOptionsPopUp),
      isShowOptionsPopUp: computed(() => this.isShowOptionsPopUp),
      hideOptionsPopUp: computed(() => this.hideOptionsPopUp),
      copyKey: computed(() => this.copyKey),
      renameWallet: computed(() => this.renameWallet),
      confirmDeleteWallet: computed(() => this.confirmDeleteWallet),
      selectSecretWallet: computed(() => this.selectSecretWallet),
      canChangeSWPage: computed(() => this.canChangeSWPage),
      changeSWPage: computed(() => this.changeSWPage),
      clearSecret: computed(() => this.clearSecret),
      importSecretWallet: computed(() => this.importSecretWallet),
      changeOrdersLog: computed(() => this.changeOrdersLog),
      showActiveSnipes: computed(() => this.showActiveSnipes),
      changeSnipeView: computed(() => this.changeSnipeView),
      nextWithdrawStage: computed(() => this.nextWithdrawStage),
      execute: computed(() => this.execute),
      getFloatWithDoublePrecision: computed(() => this.getFloatWithDoublePrecision),
      isPositiveValue: computed(() => this.isPositiveValue),
      calculateBPPercentage: computed(() => this.calculateBPPercentage),
      getBNBFromWei: computed(() => this.getBNBFromWei),
      isMevProtection: computed(() => this.isMevProtection),
      isblProtection: computed(() => this.isblProtection),
      isBlacklisted: computed(() => this.isBlacklisted),
      blProtection: computed(() => this.blProtection),
      autoOrderAction: computed(() => this.autoOrderAction),
      getOrderAction: computed(() => this.getOrderAction),
      timeConverter: computed(() => this.timeConverter),
      canChangeHPage: computed(() => this.canChangeHPage),
      changeHPage: computed(() => this.changeHPage),
      reRenderBridge: computed(() => this.reRenderBridge),
      isChainSelected: computed(() => this.isChainSelected),
      switchChain: computed(() => this.switchChain),
      fillQuick: computed(() => this.fillQuick),
      amountHandler: computed(() => this.amountHandler),
      sellamountHandler: computed(() => this.sellamountHandler),
      focusHandler: computed(() => this.focusHandler),
      isDefaultSetting: computed(() => this.isDefaultSetting),
      setDefaultSetting: computed(() => this.setDefaultSetting),
      trade: computed(() => this.trade),
      approveLabel: computed(() => this.approveLabel),
      switchPanelBuying: computed(() => this.switchPanelBuying),
      changeBP: computed(() => this.changeBP),
      amountCheck: computed(() => this.amountCheck),
      amountBPFocusLost: computed(() => this.amountBPFocusLost),
      changeTP: computed(() => this.changeTP),
      amountTPFocusLost: computed(() => this.amountTPFocusLost),
      changeSL: computed(() => this.changeSL),
      changetSL: computed(() => this.changetSL),
      computeShowExecuteButton: computed(() => this.computeShowExecuteButton),
      computeShowBlacklistProtection: computed(() => this.computeShowBlacklistProtection),
      computeShowLimitButton: computed(() => this.computeShowLimitButton),
      copyTxHash: computed(() => this.copyTxHash),
      useUSDPrice: computed(() => this.useUSDPrice),
      switchStyle: computed(() => this.switchStyle),
      inputFieldHandler: computed(() => this.inputFieldHandler),
      showSettingsPopup: computed(() => this.showSettingsPopup),
      showProfilePopup: computed(() => this.showProfilePopup),
      hideSettingsPopup: computed(() => this.hideSettingsPopup),
      hideProfilePopup: computed(() => this.hideProfilePopup),
      profileActive: computed(() => this.profileActive),
      windowHeight: computed(() => this.windowHeight),
      prevChain: computed(() => this.prevChain),
      exportKey: computed(() => this.exportKey),
      setLimitOrderSlippage: computed(() => this.setLimitOrderSlippage),
      setLimitOrderGas: computed(() => this.setLimitOrderGas),
      fromBNtoString: computed(() => this.fromBNtoString),
      LoginManagerConnect: computed(() => this.LoginManagerConnect),
      setGasPreset: computed(() => this.setGasPreset),
      useMEV: computed(() => this.useMEV),
      exportedKey: computed(() => this.exportedKey),
      changeMEV: computed(() => this.changeMEV),
      computedBotOn: computed(() => this.computedBotOn),
      computedConnected: computed(() => this.computedConnected),
      computedTokenInFavorites: computed(() => this.computedTokenInFavorites),
      computedShowBlockWarning: computed(() => this.computedShowBlockWarning),
      computedMaintenance: computed(() => this.computedMaintenance),
      computedLogs: computed(() => this.computedLogs),
      computedResults: computed(() => this.computedResults),
      computedShowCreateButton: computed(() => this.computedShowCreateButton),
      computedShowImportButton: computed(() => this.computedShowImportButton),
      computedShowImportWallet: computed(() => this.computedShowImportWallet),
      computedShowTrashClass: computed(() => this.computedShowTrashClass),
      computedShowOrdersHistory: computed(() => this.computedShowOrdersHistory),
      computedShowMarketOrders: computed(() => this.computedShowMarketOrders),
      computedWallets: computed(() => this.computedWallets),
      computedWETH: computed(() => this.computedWETH),
      computedSecretWallets: computed(() => this.computedSecretWallets),
      computedCutOrders: computed(() => this.computedCutOrders),
      computedIsProduction: computed(() => this.computedIsProduction),
      computedCurrentWalletLabel: computed(() => this.computedCurrentWalletLabel),
      computedIsPanelBuying: computed(() => this.computedIsPanelBuying),
      computedUseBP: computed(() => this.computedUseBP),
      computedUseMev: computed(() => this.computedUseMev),
      computedDisableRetry: computed(() => this.computedDisableRetry),
      computedUseTP: computed(() => this.computedUseTP),
      computedUseSL: computed(() => this.computedUseSL),
      computedtSL: computed(() => this.computedtSL),
      computedRoute: computed(() => this.computedRoute),
      computedBPAmount: computed(() => this.computedBPAmount),
      computedTxHash: computed(() => this.computedTxHash),
      computedShowWalletWarning: computed(() => this.computedShowWalletWarning),
      computedSWPage: computed(() => this.computedSWPage),
      computedOrders: computed(() => this.computedOrders),
      computedScreenSize: computed(() => this.computedScreenSize),
      classPlatform: computed(() => this.classPlatform),
      classPlatformTabletOverride: computed(() => this.classPlatformTabletOverride),
      classTablet: computed(() => this.classTablet),
      alertBlock: computed(() => this.alertBlock),
    }
  },
  mounted() {
    this.root = document.documentElement;
    if (isLocalStorage()) {
      if(localStorage.getItem('darkFTT') === null || localStorage.getItem('darkFTT') === undefined) {
        localStorage.setItem('darkFTT', true);
      } 
      this.dark = (localStorage.getItem('darkFTT') === 'true')?true:(localStorage.getItem('darkFTT') === 'false')?false:localStorage.getItem('darkFTT');
    }
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
    LoginManager.init(this);
    Scroll.init(this);
    cafeContractBSC = new web3VueBridgeBSC.eth.Contract(ABIS["ERC20"]);
    cafeContractBSC.options.address = CAFE;
    cafeContractETH = new web3VueBridgeETH.eth.Contract(ABIS["ERC20"]);
    cafeContractETH.options.address = CAFEETH;
    stakingContractBSC = new web3VueBridgeBSC.eth.Contract(ABIS["staking"]);
    stakingContractBSC.options.address = STAKING;
    stakingContractETH = new web3VueBridgeETH.eth.Contract(ABIS["staking"]);
    stakingContractETH.options.address = STAKINGETH;
    this.setRangeSettings(200,0);
    this.currentValues[4] = this.settingsGas * 5;
  },
  beforeDestroy() { 
    window.removeEventListener('resize', this.onResize); 
  },
  /*watch: {
    
  },*/
  watch: {
    dark: {
      handler:function() {
        this.changeStyle();
      },
      immediate: true
    },
    address: {
      handler:function() {
        this.checkAddress();
      }
    },
    baseWithdrawValue: {
      handler:function() {
        this.checkWithdrawAmount();
      }
    },
    deep:true,
  },
  computed: {
    computedBPAmount() {

    },
    computedTokenInFavorites() {
      if(this.currentToken) {
        if(this.favorites[this.currentToken.adr.toLowerCase()]) return true;
      }
      return false;
    },
    computedUseSL() {
      return this.useSL;
    },
    computedUseTP() {
      return this.useTP;
    },
    computedUseBP() {
      return this.useBP;
    },
    computedUseMev() {
      return this.useMEV;
    },
    computedDisableRetry() {
      return this.disableRetry;
    },
    computedIsPanelBuying() {
      return this.isPanelBuyingNow
    },
    computedLogs () {
      return this.logsArray
    },
    computedTxHash () {
      return this.logsTxHasArray
    },
    computedBotOn () {
      return this.botOn
    },
    computedShowWalletWarning () {
      return this.showWalletWarning
    },
    computedShowImportWallet () {
      return this.importWalletShow
    },
    computedWallets() {
      return this.walletsArray
    },
    computedSecretWallets() {
      if(this.secretWallets) return this.secretWallets.slice(this.swPage*6, this.swPage*6+6);
      else return null;
    },
    computedCutOrders() {
      if(this.ordersArray) return this.ordersArray.slice(this.hPage*5, this.ordersArray.length >=5?(this.hPage*5+5):this.ordersArray.length);
      else return null;
    },
    computedSWPage() {
      return this.swPage
    },
    computedShowCreateButton() {
      let resultCreate = 0
      this.walletsArray.forEach((item, index) => {
          if(!item.imported && !item.deleted) resultCreate++
      })
      //if(this.walletsArray.length == 0) resultCreate = 3
      return true;//resultCreate>=3?(process.env.NODE_ENV === 'production' ?false:true):
    },
    computedShowImportButton() {
      let resultImport = 0
      this.walletsArray.forEach((item, index) => {
          if(item.imported && !item.deleted) resultImport++
      })
      //if(this.walletsArray.length == 0) resultImport = 3
      //if(resultImport >=3) this.importWalletShow = false;
      return true;//resultImport>=3?false:
    },
    computedShowBlockWarning() {
      const show = this.blockWarningMessage.length > 0? true : false;
      return show;
    },
    computedShowTrashClass() {
      return this.showTrash;
    },
    computedMaintenance() {
      return this.maintenance;
    },
    computedCurrentWalletLabel() {
      return this.currentWallet?` ${this.computedWETH} WALLET ${this.getWalletAddressOrTag(this.currentWallet.address)}`:'';
    },
    computedResults() {
      return this.resultArray;
    },
    computedOrders() {
      return this.ordersArray;
    },
    computedRoute() {
      if(this.currentToken) {
        return this.currentToken.route;
      } else {
        return false;
      }
    },
    computedShowOrdersHistory() {
      return this.showOrdersHistory;
    },
    computedShowMarketOrders() {
      return this.showMarketOrders;
    },
    computedtSL() {
      return this.tSL
    },
    computedConnected() {
      return this.connected;
    },
    computedWETH() {
      return this.chain.symbol;
    },
    computedIsProduction() {
      return process.env.NODE_ENV === 'production'? (TESTPROD?false:true):false;
    },
    computedScreenSize() {
      return this.$matches.mobile.only?0:((this.$matches.desktop.only && this.windowHeight > 768)?2:0);
    },
    classPlatform() {
      return {
        mobile: this.computedScreenSize < 2,
        desktop: this.computedScreenSize >= 2
      }
    },
    classPlatformTabletOverride() {
      return { 
        mobile: this.classPlatform.mobile && !(this.$matches.tablet.only||(this.$matches.desktop.only && this.windowHeight <= 768)),
        desktop: this.classPlatform.desktop || (this.$matches.tablet.only||(this.$matches.desktop.only && this.windowHeight <= 768)),
      }
    },
    classTablet() {
      return (this.$matches.tablet.only||(this.$matches.desktop.only && this.windowHeight <= 768)?'tablet':false);
    }
  },
  methods: {
    checkWithdrawAmount() {
      if(!this.checkValue(this.baseWithdrawValue)||this.baseWithdrawValue == "" ||this.baseWithdrawValue ==0) {
        this.alertBlock('Amount is incorrect.', 1000)
        return false;
      }
      return true;
    },
    getWalletAddressOrTag(walletAddress) {
      try {
        const wallet = this.walletsArray.find(w => w.address === walletAddress);
        return wallet && wallet.tag ? wallet.tag : walletAddress;
      } catch(e) {
        return walletAddress;
      }
    },
    checkAddress() {
      if(!this.ignoreSearchHandler) {
        const snipe = this.showLogSection('snipe');
        let url = null;
        let chain = this.chain.ID;
        let urlPair = null;
        let addr = this.address.toString().replace(/ /g, "");
        try {
          url = new window.URL(addr.toString());
          if(url.host.toLowerCase().includes('dextools.io') || url.host.toLowerCase().includes('etherscan.io')|| url.host.toLowerCase().includes('dexscreener.com') || url.host.toLowerCase().includes('poocoin.') || url.host.toLowerCase().includes('bscscan.com') || url.host.toLowerCase().includes('geckoterminal.com')) {
            if(url.pathname.toLowerCase().includes('bnb') || url.pathname.toLowerCase().includes('bsc') || url.host.toLowerCase().includes('poocoin.') || url.host.toLowerCase().includes('bscscan.com')) chain = 56;
            if(url.pathname.toLowerCase().includes('ether') || url.pathname.toLowerCase().includes('ethereum')||url.host.toLowerCase().includes('etherscan.io')) chain = 1;
            if(url.host.toLowerCase().includes('geckoterminal.com') && url.pathname.toLowerCase().includes('eth')) chain = 1;
            const pathname = url.pathname.split('/');
            urlPair = pathname[pathname.length-1];  
            urlPair = urlPair.toLowerCase();
            if(!Web3.utils.isAddress(urlPair)) url = false;
            else addr = urlPair;
          }    
        } catch(e) {
        }
        addr = addr.toLowerCase();
        if(Web3.utils.isAddress(addr) || url) {
          this.newSearch = addr;
          if(this.prevSearch != this.newSearch || true) {
            this.prevSearch = this.newSearch;
            if(!snipe) {
              if(!url) this.search();
              else this.search(this.newSearch, true, {chain: chain, address:this.newSearch});
            }
          }
        }
        this.ignoreSearchHandler = false;
      } else {
        this.ignoreSearchHandler = false;
      }
    },
    switchBridgeDestination() {
      this.bridgeToETH = !this.bridgeToETH;
      this.reRenderBridge += 1;
    },
    onResize() {
      this.windowHeight = window.innerHeight
    },
    inputFieldHandler(val, field, chainEvent, chainEventArg = null) {
      this[field] = val
      if(chainEvent) {
        if(chainEventArg != null) this[chainEvent](chainEventArg);
        else this[chainEvent]();
      }
    },
    generateNonce(addr) {
      try{
        axios.post(URL+'/nonce', {address:addr, version: VERSION},{
          headers: {
            "Content-Type": "application/json"
          },
          withCredentials: true
        }).then((response) => {
                if (response.status == 200) {
                  return response.data;
                } else return Promise.reject(response);
              }).then((data) => {
                if(data.data == "stored-ok") this.socket.connect();
                else LoginManager.AuthenticateWithWallet(data.data);
                this.PushNotify(data.msg)
              })      .catch((response) => {
          if(response&&response.response&&response.response.data&&response.response.data.msg) {
                    this.PushErr(response.response.data.msg)
                  } else this.PushErr("Failed to execute request.")
      });
              /*
               
              */
      } catch(e) {
        this.PushErr("Failed to execute request.")
      }
      
    },
    authenticateWithSign(addr, nonce, sign) {
       try{
        let ref = (new URLSearchParams(window.location.search)).get('ref');
        if(!ref) ref = '';
      axios.post(URL+'/authWithSign',{addr: addr, nonce: nonce, sign: sign, version: VERSION, referral:ref},{
        headers: {
          "Content-Type": "application/json"
        },
        withCredentials: true
        }).then((response) => {
        if (response.status == 200) {
          this.socket.connect();
          return response.data;
        } else return Promise.reject(response);
      })
      .then((data) => {
        this.PushNotify(data.msg);
      })
      .catch((response) => {
          if(response&&response.response&&response.response.data&&response.response.data.msg) {
                    this.PushErr(response.response.data.msg)
                  } else this.PushErr("Request blocked or too many requests.")
      });
         } catch(e) {
        this.PushErr("Request blocked or too many requests.")
      }
    },
    connect(wall = false) {
      this.hPage = 0;
      if(wall) this.authWallet = wall;
    },
    LoginManagerConnect() {
      LoginManager.onConnect();
    },
     providerDisconnect() {
      this.providerConnect = false;
    },
    hideHelpPopup() {
      this.helpActive = false;
    },
    showHelpPopup() {
      this.helpActive = true;
    },
    providerConnected() {
      this.providerConnect = true;
    },
    disconnect() {
      this.connected = false;
      this.hPage = null;
      this.authWallet = null;
      this.cafe = {
        BSC: 0,
        ETH: 0,
        BSCWALLET: 0,
        ETHWALLET: 0,
      };
      this.referralData = null;
      this.freeUpgradeAvailable = false;
      this.refEarnings = 0;
      if(this.socket.connected) this.socket.disconnect();
      try{
         this.walletsArray = []
         this.withdrawalsArray = []
          this.deletedWalletsExists = false;    
          this.currentWallet = null;
          this.clearSecret();
          this.USDPrice = 0;
          this.MCAP = 0;
          this.LP = 0;
          this.useUSDPrice();
          this.ordersArray = [];
          this.autoTrades = {};
          this.marketTrades = {};
      } catch(e) {

      }
    },
    changeStyle() {
      this.styleChanged++;    
      this.$nextTick(() => {
           if (this.dark === true) {

            this.root.style.setProperty("--black", states.Theme.black.dark);
            this.root.style.setProperty("--bon-jour", states.Theme.bon_jour.dark);
            this.root.style.setProperty("--bon-jour-2", states.Theme.bon_jour_2.dark);
            this.root.style.setProperty("--cedar-chest", states.Theme.cedar_chest.dark);
            this.root.style.setProperty("--irish-coffee", states.Theme.irish_coffee.dark);
            this.root.style.setProperty("--jade", states.Theme.jade.dark);
            this.root.style.setProperty("--satin-linen", states.Theme.satin_linen.dark);
            this.root.style.setProperty("--sepia-skin", states.Theme.sepia_skin.dark);
            this.root.style.setProperty("--sepia-skin-2", states.Theme.sepia_skin_2.dark);
            this.root.style.setProperty("--blue-link", states.Theme.blue_link.dark);
            this.root.style.setProperty("--filter", states.Theme.filter.dark);
            this.root.style.setProperty("--filter-active", states.Theme.filter_active.dark);
            this.root.style.setProperty("--filter-hollow", states.Theme.filter_hollow.dark);

            if (isLocalStorage()) {
              if(localStorage.getItem('darkFTT') !== null && localStorage.getItem('darkFTT') !== undefined) {
                localStorage.setItem('darkFTT', this.dark === 'true'? true : this.dark === 'false'? false: this.dark);
              }
            }

         } else if(this.dark === false){

            this.root.style.setProperty("--black", states.Theme.black.light);
            this.root.style.setProperty("--bon-jour", states.Theme.bon_jour.light);
            this.root.style.setProperty("--bon-jour-2", states.Theme.bon_jour_2.light);
            this.root.style.setProperty("--cedar-chest", states.Theme.cedar_chest.light);
            this.root.style.setProperty("--irish-coffee", states.Theme.irish_coffee.light);
            this.root.style.setProperty("--jade", states.Theme.jade.light);
            this.root.style.setProperty("--satin-linen", states.Theme.satin_linen.light);
            this.root.style.setProperty("--sepia-skin", states.Theme.sepia_skin.light);
            this.root.style.setProperty("--sepia-skin-2", states.Theme.sepia_skin_2.light);           
            this.root.style.setProperty("--blue-link", states.Theme.blue_link.light);
            this.root.style.setProperty("--filter", states.Theme.filter.light);
            this.root.style.setProperty("--filter-active", states.Theme.filter_active.light);
            this.root.style.setProperty("--filter-hollow", states.Theme.filter_hollow.light);

            if (isLocalStorage()) {
              if(localStorage.getItem('darkFTT') !== null && localStorage.getItem('darkFTT') !== undefined) {
                localStorage.setItem('darkFTT', this.dark === 'true'? true : this.dark === 'false'? false: this.dark);
              }
            }
          }
        })
    },
    switchStyle(isDark) {
      this.dark = isDark;
    },
    updateWalletUse(index) {
      if(this.socket.connected) this.socket.emit('updateWalletUse',index)
      else this.PushNotify(" > Authentication is needed to do this action.")
      this.reRenderUse += 1;
    },
    createWallet() {
      this.clearSecret();
      if(this.socket.connected) this.socket.emit('createWallet')
      else this.PushNotify(" > Authentication is needed to do this action.")
    },
    importWallet(pk = null) {
      this.clearSecret();
      if(this.socket.connected) this.socket.emit('importWallet',pk?pk:this.inputImportKey)
      else this.PushNotify(" > Authentication is needed to do this action.")
      this.showImportField(true)
    },
    showImportField(hide = false) {
      if(!hide) this.importWalletShow = !this.importWalletShow;
      else this.importWalletShow = false;
      this.inputImportKey = ''
    },
    copyToClipboard(textToCopy) {
      let textArea = document.createElement("textarea");
      textArea.value = textToCopy;
      // make the textarea out of viewport
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      return new Promise((res, rej) => {
          document.execCommand('copy') ? res() : rej();
          textArea.remove();
      }); 
    },
    pasteFromClipboard() {
      let textArea = document.createElement("textarea");
      // make the textarea out of viewport
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      return new Promise((resolve, reject) => {
        let successful = document.execCommand("paste");
        let text = textArea.value;
        textArea.remove();
        successful ? resolve(text) : reject('Failed to paste');
    });

    },
    async pasteToSearchbar() {
      let text;
      this.address='';
      try {
        text = await navigator.clipboard.readText();
        this.address=text;
      } catch (err) {
        this.pasteFromClipboard().then((val) => { this.address = val;}).catch((e) => {this.alertWallet('Cannot paste from clipboard: ' + e, 1000)});
      }
    },
    async copyAddress(walAddr) {
      this.copyToClipboard(walAddr).then(() => { this.alertWallet('Wallet address copied to clipboard.', 1000)}).catch((e) => {this.alertWallet('Cannot copy wallet address.' + e, 1000)});
    },
    async copyRefLink() {
      if(this.user) {
      this.copyToClipboard('https://trading.def.cafe/?ref='+this.user.reflink).then(() => { this.alertWallet('Referral link to clipboard.', 1000)}).catch((e) => {this.alertWallet('Referral link. ' + e, 1000)});
      this.hideProfilePopup();
      }
    },
    async copyKey(pkey) {
      this.copyToClipboard(pkey).then(() => { this.alertWallet('Private key copied to clipboard.', 1000)}).catch((e) => {this.alertWallet('Cannot copy private key.' + e, 1000)});
    },
    async copyTxHash(hash) {
      this.copyToClipboard(hash).then(() => { this.alertBlock('txHash copied to clipboard.', 1000)}).catch((e) => {this.alertBlock('Cannot copy txhash.' + e, 1000)});
    },
    alertWallet(message, time) {
      this.alertBlock(message,time);
    },
    alertBlock(message, time) {
      if(this.blockWarningTimeout) clearTimeout(this.blockWarningTimeout);
      this.blockWarningMessage = this.toUpperCase(message);
      this.blockWarningTimeout = setTimeout(this.clearWalletMessage, time);
    },
    toUpperCase(str) {
      return (str.toString()).toUpperCase()
    },
    clearWalletMessage() {
      this.walletWarningMessage = '';
      this.blockWarningMessage = '';
    },
    updateWalletBalanceAtIndex(index,balance) {
      if(this.walletsArray) {
        try {
          if(this.walletsArray[index].used && this.currentWallet.balanceOverride) {
          // this.currentWallet.balance = this.walletsArray[index].balance
          } else {
            const ethBalance = Web3.utils.fromWei(balance, "ether");
            let humanFriendlyBalance = parseFloat(ethBalance).toFixed(3);
            if(parseFloat(ethBalance) < 0.001) humanFriendlyBalance = parseFloat(ethBalance).toFixed(0);
            this.walletsArray[index].balance = humanFriendlyBalance
          }
          this.reRender += 1
        } catch(e) {
        }
      }
    },
    updateSecretWalletBalanceAtIndex(index,balance) {
      if(this.secretWallets) {
          const ethBalance = Web3.utils.fromWei(balance, "ether");
          let humanFriendlyBalance = parseFloat(ethBalance).toFixed(3);
          if(parseFloat(ethBalance) < 0.001) humanFriendlyBalance = parseFloat(ethBalance).toFixed(0);
          this.secretWallets[index]['balance'] = humanFriendlyBalance
      }
    },
    updateTokenBalanceOfCurrentWallet(bal) {
      if(this.currentWallet) {
        if(!this.currentWallet.balanceOverride) {
          this.currentWallet.tokenBalance = bal;
        }
      }
    },
    showLogSection(section) {
      return this.currentScreen == section ? true : false;
    },
    showWalletRow(index) {
      let show = false;
      if(this.walletsArray.length) {
        if(this.walletsArray[index].deleted && !this.computedShowTrashClass) {
          show = true;
        }
        if(this.walletsArray[index].deleted && this.computedShowTrashClass) {
          show = false;
        }
        if(!this.walletsArray[index].deleted && this.computedShowTrashClass) {
          show = true;
        }
        if(!this.walletsArray[index].deleted && !this.computedShowTrashClass) {
          show = false;
        }
      }
      return show;
    },
    useDirectPairOnStable() {
      if(this.currentToken && this.currentToken.packedDirectData) return this.currentToken.packedDirectData && this.chain.pairsTagsLocale[this.currentToken.adr.toLowerCase()]?true:false;
      else return false;
    },
    renameActive(index) {
      let show = false;
      if(this.walletsArray.length) {
        if(!this.walletsArray[index].deleted && this.currentRename == index) {
          show = true;
        }
      }
      return show;
    },
    switchLogSection(section) {
      this.currentScreen = section;
      this.currentWalletOptions = 0;
      this.clearSecret();
      if(section == 'logs') {
        const logsDiv = document.getElementById('logsMain')
          this.$nextTick(() => {
          if(logsDiv) logsDiv.scrollTop = logsDiv.scrollHeight
        })
      }
      if(section == 'settings') {

      } else {
        /*if(this.settingsJSMounted && this.scrollScriptSettings) {
          document.head.removeChild(this.scrollScriptSettings)
          this.settingsJSMounted = false;
          this.scrollScriptSettings = null;
        }*/
      }
      if(section == 'snipe') {
        if(!this.computedUseMev) this.changeMEV();
        if(!this.isPanelBuyingNow) {
          this.switchPanelBuying();
        }
      }
    },
    confirmDeleteWallet(index) {
      this.walletForDeletion = index;
      this.currentWalletOptions = 0;
      this.clearSecret();
      this.currentScreen = 'popup';
    },
    showSettingsPopup() {
      this.settingsActive = true;
    },
    showProfilePopup() {
      this.profileActive = true;
    },
    hideProfilePopup() {
      this.profileActive = false;
    },
    hideSettingsPopup() {
      this.settingsActive = false;
    },
    cancelDeleteWallet() {
      this.currentWalletOptions = 0;
      this.clearSecret();
      this.walletForDeletion = null;
      this.currentScreen = 'wallets';
    },
    deleteWallet() {
      if(this.socket.connected) this.socket.emit('deleteWallet',this.walletForDeletion);
      else this.PushNotify(" > Authentication is needed to do this action.")
      this.currentScreen = 'wallets';
    },
    switchWalletView() {
      if(this.deletedWalletsExists) {
        this.showTrash = !this.showTrash;
        this.currentWalletOptions = 0;
        this.clearSecret();
      } else {
        this.currentWalletOptions = 0;
        this.clearSecret();
        this.alertWallet("You haven't deleted wallets yet, nothing to show.", 2000);
      }
    },
    showEmpty() {
      return ((!this.walletsArray.length) || this.computedShowTrashClass && !this.walletsArray.filter(item => (!item.deleted)).length); 
    },
    fillBalance(bal, quick = false) {
      if(this.currentWallet) {
        if(this.currentWallet.balance != undefined || this.currentWallet.balance != null ) {
          if(bal == 0) {
            this.amount = bal;
          } else {
            const res = parseFloat(this.currentWallet.balance/100*bal);
            if(res > parseFloat(0.001)) {
              this.amount = res;
            } else {
              this.alertWallet('Balance is to low to divide.', 1000);
              this.alertBlock('Balance is to low to divide.', 1000);
              this.amount = 0;
            }
          }
          this.buyPercentage = bal;
          if(quick) this.currentValues[0] = bal*5;
          this.botSwapFocus = false;
          this.recalcRecommendedBal();
        } else {
          this.alertWallet('Wallet balance is loading. Please wait.', 1000)
          this.alertBlock('Wallet balance is loading. Please wait.', 1000);
        }
      } else {
        this.alertWallet('Wallet is not loaded. Connect and/or choose the wallet to use.', 1000)
        this.alertBlock('Wallet is not loaded. Connect and/or choose the wallet to use.', 1000);
      }
    },
    fillToken(bal,quick = false) {
      if(this.currentWallet && this.currentToken) {
        if(this.currentWallet.tokenBalance != undefined || this.currentWallet.tokenBalance != null ) {
          if(bal == 0) {
            this.sellamount = '0';
            this.currentToken.BNAmount = '0';
          } else {
            const res = (Web3.utils.toBN(this.currentWallet.tokenBalance).mul(Web3.utils.toBN(bal))).div(Web3.utils.toBN(100)).toString();
            this.currentToken.BNAmount = res;
            if(Web3.utils.toBN(res).cmp(Web3.utils.toBN(0)) > 0) this.sellamount = this.fromBNtoString(this.currentToken.BNAmount);
            else this.sellamount = '0';
          }
          this.buyPercentage = bal;
          if(quick) this.currentValues[0] = bal*5;
          this.botSwapFocus = false;
          this.recalcRecommendedBal();
        } else {
          this.alertWallet('Token balance is loading. Please wait.', 1000)
          this.alertBlock('Token balance is loading. Please wait.', 1000);
        }
      } else {
        this.alertWallet('Token is not loaded. Connect and/or choose the wallet to use.', 1000)
        this.alertBlock('Token is not loaded. Connect and/or choose the wallet to use.', 1000);
      }
    },
    async focusHandler(sell) {
      this.botSwapFocus = this.isPanelBuyingNow?(sell?true:false):(sell?false:true);
      this.recalcRecommendedBal();
    },
    async swapHandler(force = false) {
      if(this.isPanelBuyingNow) this.amountHandler();
      else this.sellamountHandler();
      this.recalcRecommendedBal();
    },
    isUniswapV3() {
      return this.currentSwap.name == "UniswapV3"?true:false;
    },
    async updateUSDPrice() {
      if(this.currentToken) {
        let prevC = this.prevChain;
        try {
          let wethBal = 0;
          let tokBal = 0; 
          let totalSupply = 0;
          let useMHPairOnStable = this.useDirectPairOnStable();
          let stable = this.chain.pairsTagsLocale[this.currentToken.adr.toLowerCase()]?true:false;
          let tempPacked = !useMHPairOnStable?this.currentToken.packedData:this.currentToken.packedDirectData;
          let tempPair = tempPacked.path;
          let tempPairReversed = tempPacked.reversedPath;
          let USDPath = quoterWeb3.isV3? this.chain.USDPAIRPACKED: this.chain.USDPAIR;
          let amountIn = Web3.utils.toBN(10**parseInt(this.currentToken.dec)).toString();
          let WETHPrice = 0;
          let price = 0;
          let currentUSDPrice = 0;
          let diff = [0,0];

          let aggregateResults1 = await multicall.aggregate([
            WETHcontract.methods.balanceOf(this.currentToken.pair),
            tokenContract.methods.balanceOf(this.currentToken.pair),
            tokenContract.methods.totalSupply(),
            quoterWeb3.getAmountsOutMethod(Web3.utils.toWei((1000).toString(),'gwei'), tempPair),
            quoterWeb3.getAmountsOutMethod(Web3.utils.toWei(amountIn.toString(),'wei'), tempPairReversed)
          ])
          currentUSDPrice = await quoterWeb3.getAmountsOut(Web3.utils.toWei('1','ether'), USDPath);
          wethBal = aggregateResults1[0];
          tokBal = aggregateResults1[1];
          totalSupply = aggregateResults1[2];
          if(!quoterWeb3.isV3) {
            diff[0] = aggregateResults1[3][aggregateResults1[3].length-1];
            diff[1] = aggregateResults1[4][aggregateResults1[4].length-1];
          } else {
            diff[0] = aggregateResults1[3];
            diff[1] = aggregateResults1[4];
          }

          currentUSDPrice = currentUSDPrice.toString();
          if(this.currentToken&&prevC == this.chain.ID){
          let wayDirect = false;
          if(diff[0] >= 0) wayDirect = true;
          if(diff[1] == 0) wayDirect = false;
          if(!wayDirect&&!stable) amountIn = diff[0];
          if(stable) {
            wayDirect = false;
            if(this.chain.ID == 56) {
              WETHPrice = await quoterWeb3.getAmountsOut(Web3.utils.toWei((1).toString(),'ether'), tempPacked);
              price = WETHPrice;
            } else {
              price = Web3.utils.toBN(Web3.utils.toWei('1','ether')).mul(Web3.utils.toBN(currentUSDPrice));
            }
          } else {
            WETHPrice =  await quoterWeb3.getAmountsIn(Web3.utils.toWei(amountIn.toString(),'wei'), tempPacked);
            price = WETHPrice;
            if(WETHcontract.options.address.toLowerCase() != this.chain.USDAddress.toLowerCase()) {
              if(this.chain.ID == 56) {
                price = await quoterWeb3.getAmountsOut(Web3.utils.toWei(WETHPrice.toString(),'wei'), USDPath);
              } else {
                price = Web3.utils.toBN(price.toString()).mul(Web3.utils.toBN(currentUSDPrice));
              }
            }
          } 
          if(this.currentToken&&prevC == this.chain.ID){
            if(this.chain.ID == 56) {
              price = Web3.utils.fromWei(price.toString(), 'ether');
            } else {
              price = Web3.utils.fromWei(price.toString(), 'mether');
            }

            if(!wayDirect) {
              let multiplier = Number(this.fromBNtoString(amountIn.toString()));
              price = (Number(price)/multiplier);
            }
            
              if(stable) {
                this.MCAP = Number((parseFloat(this.fromBNtoString(totalSupply))*parseFloat(1)).toFixed(0));
              } else {
                this.MCAP = Number((parseFloat(this.fromBNtoString(totalSupply))*parseFloat(price)).toFixed(0));
              }
            this.USDPrice = Number(price);
            if(this.chain.pairsTagsLocale[WETHcontract.options.address.toLowerCase()]) {
              this.LP = this.getFloatWithDoublePrecision(parseFloat(this.fromBNtoString(wethBal, this.currentToken.wethDec)).toString(), true) + " " +this.chain.pairsTagsLocale[WETHcontract.options.address.toLowerCase()];
            } else {
              this.LP = this.getFloatWithDoublePrecision(parseFloat(this.fromBNtoString(wethBal, this.currentToken.wethDec)).toFixed(2).toString(), true)+ " " +this.chain.pairsTags[WETHcontract.options.address.toLowerCase()];
            }
          }
          }
        } catch(e) {
        }
     }
    },
    async amountHandler() {
     if(this.currentToken) {
      let res = '0';
      if(!this.botSwapFocus) {
          try {    
            res = await quoterWeb3.getAmountsOut(Web3.utils.toWei(this.amount.toString(), 'ether'), this.currentToken.packedData);
            } catch(e) {
          }
          this.sellamount = this.fromBNtoString(res.toString());
      } else {
          try {    
            const vals = this.parseBN(this.sellamount);
            const sellWei = this.towei(vals).toString();
            res = await quoterWeb3.getAmountsIn(sellWei, this.currentToken.packedData, false);
            } catch(e) {
          }
        this.amount = Web3.utils.fromWei(res, 'ether');
      }
      this.recalcRecommendedBal();
     }
    },
    async recalcRecommendedBal() {
      try {
        if(this.currentToken) {
        let gasPrice = 0;
          if(this.currentBlockData.gas) {
            if(this.currentBlockData.gas.isLegacy) {
              gasPrice = this.currentBlockData.gas.current[this.gasPreset];
            } else {
              gasPrice = this.useMEV&&this.chain.ID != 56?this.currentBlockData.gas.mev[this.gasPreset].maxFeePerGas:this.currentBlockData.gas.current[this.gasPreset].maxFeePerGas;
            }
          }
          gasPrice = gasPrice*parseInt(this.currentToken.estAMT);
          let amtFixed = parseFloat(this.amount).toFixed(18);
          this.minBalToSend = web3Vue.utils.toBN(gasPrice.toString()).add(web3Vue.utils.toBN(gasPrice.toString()).mul(web3Vue.utils.toBN(100)).div(web3Vue.utils.toBN(175)));
          let amtWei = web3Vue.utils.toBN(web3Vue.utils.toWei(amtFixed.toString(), 'ether')).toString();
          let addition = !this.isPanelBuyingNow || parseFloat(amtFixed) == 0?web3Vue.utils.toBN(0):
          this.botSwapFocus?
            web3Vue.utils.toBN(amtWei).add(web3Vue.utils.toBN(amtWei).div(web3Vue.utils.toBN(100)).mul(web3Vue.utils.toBN(this.settingsSlippage))):
            web3Vue.utils.toBN(amtWei);
          this.minBalToSend = (this.minBalToSend.add(addition)).toString()
          this.minBalToSend = this.getFloatWithDoublePrecision(web3Vue.utils.fromWei(this.minBalToSend.toString(),'ether').toString(), true, true, 2);
        }
      } catch(e) {
      }
    },
    async sellamountHandler() {
    if(this.currentToken) {
      let res = '0';
      if(!this.botSwapFocus) {
        const vals = this.parseBN(this.sellamount);
        const sellWei = this.towei(vals).toString();
          try {    
            res = await quoterWeb3.getAmountsOut(sellWei, this.currentToken.packedData, true);
            } catch(e) {
          }
        this.amount = Web3.utils.fromWei(res, 'ether');
      } else {
        try {    
          res = await quoterWeb3.getAmountsIn(Web3.utils.toWei(this.amount.toString()), this.currentToken.packedData, true);
          } catch(e) {
        }
        this.sellamount = this.fromBNtoString(res.toString());
      }
     this.recalcRecommendedBal();
     }
    },
    async amountCheck(tp = false) {
      if(tp&&!this.checkValue(this.takeProfit)||!tp&&!this.checkValue(this.priceTriggerAmount)) this.alertBlock("Incorrect input value",1000);
    },
    amountBPFocusLost(e = null) {
      if(!this.checkValue(this.priceTriggerAmount)){
        this.alertBlock("Incorrect input value",1000);
        this.priceTriggerAmount = 0;
      }
    },
    amountTPFocusLost(e = null) {
      if(!this.checkValue(this.takeProfit)) {
        this.alertBlock("Incorrect input value",1000);
        this.takeProfit = 0;
      }
    },
    GetBuyPercentage() {

    },
    async search(address = null, fav = false, favitem = null) {
      if(!this.botOn&&!this.searchInProgress) {
        this.approved = false;
        if(favitem) {
          if(this.socket.connected) this.socket.emit('favSearch',{chain: favitem.chain, address:favitem.address.toString().replace(/ /g, "")});
          else this.PushNotify(" > Authentication is needed to do this action.")
        } else {
          if(this.socket.connected) this.socket.emit('search',address?address.toString().replace(/ /g, ""):this.address.toString().replace(/ /g, ""))
          else this.PushNotify(" > Authentication is needed to do this action.")
        }
        if(fav&&address) {
          this.ignoreSearchHandler = true;
          this.address = address;
        }
      }
    },
    clearSearch(address = null, fav = false) {
      if(this.address) {
        this.address = "";
      }
    },
    isBNB(chainID) {
      if(chainID) {
        if(chainID == 56) return true;
        else return false;
      } else return true;
    },
    trade(sell, launch = false) {
        let err = false; 
        let data = {}
        if(this.chain&&this.chain.ID !=56 && !this.approved&&(sell||this.useTP||this.useSL) && !launch) {
          this.setEarlyApproval(true);
          return;
        }
        if(this.currentToken != null &&!launch || launch&&this.address&&this.address != "") { 
          let amount = 0;
          let exactTokens = false;
          let exactAmount = 0;
          if(!sell) {    
            amount = Web3.utils.toWei(this.amount.toString(), 'ether');
            if(!launch) {
              const vals = this.parseBN(this.sellamount);
              try{
                this.currentToken.BNAmount = this.towei(vals).toString();
              }     
              catch(e) {
                err = true;
              }
            }
           
            exactTokens = !launch?this.botSwapFocus?true:false:false;
            if(exactTokens) exactAmount = this.currentToken.BNAmount;
            else exactAmount = 0;
          }
          else {
            const vals = this.parseBN(this.sellamount);
            try{
              this.currentToken.BNAmount = this.towei(vals).toString();
            }     
            catch(e) {
              err = true;
            }
            amount = this.currentToken.BNAmount;
            exactTokens = false;
            exactAmount = 0;
          }
          if(launch) this.useBP = false;

            data = {
              launch: launch,
              sell: sell,
              amount: amount.toString(),
              exactTokens: !launch?exactTokens:false,
              exactAmount: exactAmount.toString(),
              BP: !launch?this.useBP:false,
              tSL: this.tSL,
              SL: this.useSL,
              TP: this.useTP,
              SLAmount: parseInt(this.stopLoss),
              TPAmount: parseInt(this.takeProfit),
              BPPrice: this.priceTriggerAmount.toString(),
              hash: !launch?this.currentToken.hash:this.address.toLowerCase(),
              mev: !launch?this.useMEV:true,
              disableRetry: this.disableRetry,
              maxPrice: !launch?0:parseInt(this.settingsGas),
          }
        }
       if(!this.botOn) {
        if(this.useBP&&this.priceTriggerAmount > this.USDPrice) {
          this.alertBlock('Limit price should be lower than current price.', 2000);
        return;
       }
         if(!err) {
          if(this.socket.connected) {
            this.socket.emit('trade', data);
          }
          else this.PushNotify(" > Authentication is needed to do this action.")
         }
         else this.alertBlock('Invalid amount value', 1000);
       }

    },
    upgradeTier() {
      this.hideProfilePopup();
      if(this.socket.connected) {
            this.socket.emit('upgradeTier');
          }
      else this.PushNotify(" > Authentication is needed to do this action.")
    },
    bridge() {
      if(this.checkWithdrawAmount()) {
        if(this.socket.connected) {
            this.socket.emit('bridge', {amount:this.baseWithdrawValue.toString(), toeth:this.bridgeToETH});
          }
        else this.PushNotify(" > Authentication is needed to do this action.")
      } else {
        this.alertBlock('Incorrect amount value.', 2000);
      } 
    },
    nextWithdrawStage(index) {
      if(this.socket.connected) {
        this.socket.emit('nextWithdrawStage', index);
      }
      else this.PushNotify(" > Authentication is needed to do this action.")
    },
    towei(bal) {
      if(this.currentToken) {
        const decBN = Web3.utils.toBN(10**this.currentToken.dec);
        return Web3.utils.toBN(bal[0])
                .mul(decBN)
                .add(Web3.utils.toBN(bal[1]));
      }
      else return 0;
    },
    fromBNtoString(str, dec = false) {
      if(this.currentToken) {
        if(dec === false ) dec = this.currentToken.dec;
      }
      if(dec) {
         if(str.length > parseInt(dec)) {
          str = str.substring(0, str.length - parseInt(dec))+'.'+str.substring(str.length - parseInt(dec), str.length)
        } else {
          const sL= parseInt(dec) - str.length;
          for(let i = 0; i < sL; i++) {
                str = '0'+str;
              }
              str = '0.'+str;
        }
        return str;
      }
      return str;
    },
    fromBNtoBNB(str) {
      if(str.length > 18) {
        str = str.substring(0, str.length - 18)+'.'+str.substring(str.length - 18, str.length)
      } else {
        const sL= 18 - str.length;
        for(let i = 0; i < sL; i++) {
              str = '0'+str;
            }
            str = '0.'+str;
      }
      return parseFloat(str).toFixed(3);
    },
    decimalCount(num) {
      // String Contains Decimal
      if(typeof num == 'string') {
        if (num.includes('.')) {
            return num.split('.')[1].length;
        };
      }
      return 0;

    },
    parseBN(num) {
      let arr = [];
      let dc = this.decimalCount(num);
      if (typeof num == 'string' && num.includes('.')) {
          arr.push(num.split('.')[0]);
          arr.push(num.split('.')[1]);
          if(dc > parseInt(this.currentToken.dec)) arr[1] = arr[1].substring(0, parseInt(this.currentToken.dec))
          else {
            for(let i = 0; i < parseInt(this.currentToken.dec) - dc; i++) {
              arr[1] += '0';
            }
          }
      } else {
        arr.push(num);
        arr.push('0');
      }
      return arr;
    },
    tradehandler() {
    },
    calculateBPPercentage(val1, val2) {
      val1 = parseFloat(val1);
      val2 = parseFloat(val2);
      return (parseFloat((val2/val1*100.0-100.0).toFixed(2)));
    },
    getFloatWithDoublePrecision(value, view = false, cutToFixed = false, fixedPart = 6) {
      let fl = value;
      if(typeof(fl) != 'string') {
        fl = parseFloat(value).toString();  
      }
      let res = 0.0;
      if(fl) {
        if(fl.includes("e-")) {
          let flPart = fl.split("e-")[0];
          let exp = fl.split("e-")[1];
          let e1 = flPart.split(".")[0];
          let e2 = flPart.split(".")[1];
          let tempRes = ""
          if(e1) tempRes = e1;
          if(e2) tempRes = tempRes+e2;     
          if(tempRes.length > 4) tempRes = tempRes.slice(0,4);
          for(let i = 0; i < parseInt(exp)-1; i++) {
            tempRes = "0"+tempRes;
          }
          tempRes = "0."+tempRes;
          if(tempRes.length > 20) tempRes = tempRes.slice(0,20);
          let zeros = 0;
          for(let i = tempRes.length-1; i>2; i--) {
            if(tempRes[i] === "0") zeros++;
            else break;
          }
          if(zeros > 0) tempRes = tempRes.slice(0, tempRes.length - zeros);
          res = tempRes;
        } else {
          let p1 = fl.split(".")[0];
          let p2 = fl.split(".")[1];
          let long = false;
          let pr;
          let ps = '';
          let z = 0;
          if(p1) {
            if(!view) res = parseFloat(parseFloat(p1).toPrecision(7));
            else {
              switch(true) {
                case (p1.length >=7 && p1.length < 10):
                  long = true;
                  pr = p1.slice(0, p1.length - 6);
                  ps = p1.slice(p1.length - 6, p1.length - 3);
                  for(let i = ps.length-1; i >=0; i--) {
                    if(parseInt(ps[i]) == 0) z++;
                    else break;
                  }
                  ps = ps.slice(0, ps.length - z);
                  res = pr+(ps.length > 0? "."+ps:'')+"M";
                break;
                case (p1.length >=10):
                  long = true;
                  pr = p1.slice(0, p1.length - 9);
                  ps = p1.slice(p1.length - 9, p1.length - 6);
                  for(let i = ps.length-1; i >=0; i--) {
                    if(parseInt(ps[i]) == 0) z++;
                    else break;
                  }
                  ps = ps.slice(0, ps.length - z);
                  res = pr+(ps.length > 0? "."+ps:'')+"B";
                break;
                default:
                  long = false;
                  res = parseFloat(parseFloat(p1).toPrecision(7));
                break;
              }
            }
          }
          if(!long && p2) {
            p2 = "0."+p2;
            p2 = parseFloat(parseFloat(p2).toPrecision(4));
            res = res + p2;
          }
        }
      }
      if(view) {
        res = res.toString();
        if(res.includes(".")) {
          let r1 = res.split(".")[0];
          let r2 = res.split(".")[1];
          let zeros = 0;
          let notZero = 0;
          if(r2.length > 7) {
            for(let i = 0; i < r2.length; i++) {
              if(r2[i] == "0") zeros++;
              else {
                notZero = i;
                break;
              }
            }
          }
          if(zeros > 4 && notZero > 0) {
            res = {text:[]};
            res.text.push(r1+".0");
            res.text.push(zeros.toString());
            res.text.push(r2.slice(notZero, r2.length - notZero > 3?notZero+3:r2.length));
          } else if(r2.length > 7){
            if(cutToFixed) res = r1+"."+((parseFloat("0."+r2).toFixed(fixedPart)).toString()).split(".")[1];
          }
        }
      }
      return res;
    },
    approveLabel(sell) {
      return  ((this.chain&&this.chain.ID != 56&&this.currentToken&&!this.approved&&sell)||
              (this.chain&&this.chain.ID != 56&&this.currentToken&&!this.approved&&!sell&&(this.useTP||this.useSL)))?
              "approve":(sell?"sell":"buy");
    },
    async PushNotify(msg) {
      let cls = 1
      const logsDiv = document.getElementById('logsMain')
      let txhash = null;
      this.logsArray.push(msg)
      this.logsTxHasArray.push(txhash)
      this.logsClass.push(this.logsClassArray[cls])
      this.resultArray.push(null)
      this.$nextTick(() => {
        if(logsDiv) logsDiv.scrollTop = logsDiv.scrollHeight
      })
    },
    async PushErr(msg) {
      let cls = 3
      const logsDiv = document.getElementById('logsMain')
      let txhash = null;
      this.logsArray.push(msg)
      this.logsTxHasArray.push(txhash)
      this.logsClass.push(this.logsClassArray[cls])
      this.resultArray.push(null)
      this.$nextTick(() => {
        if(logsDiv) logsDiv.scrollTop = logsDiv.scrollHeight
      })
    },
    async setEarlyApproval(force = false) {
      try {
        if(this.currentToken) {
          let sendApprove = false;
          let approved = false;
          if(!force) {
            await tokenContract.methods.allowance(this.currentWallet.address, this.currentSwap.address).call({from: this.currentWallet.address}, function(error, result){ 
              if(result) {
                if(parseInt(result) > parseInt(parseInt(115792089237316195423570985008687907853269984665640564039457584007913129639935) / 2)) {
                  approved = true;
                } else {
                  sendApprove = true;
                }
              }  
            }); 
          } else {
            sendApprove = true;
          }
          this.approved = approved;
          if(this.chain.ID != 56 && !force) sendApprove = false;
          if(!sendApprove) return;
          const logsDiv = document.getElementById('logsMain')
          let txhash = null;
          this.logsArray.push('Selected wallet is not approved for selling on this token. Trying to approve...')
          this.logsTxHasArray.push(txhash)
          this.logsClass.push(this.logsClassArray[2])
          this.resultArray.push(null)
          this.$nextTick(() => {
            if(logsDiv) logsDiv.scrollTop = logsDiv.scrollHeight
          })
          if(this.currentToken &&this.currentToken.adr) {
            if(this.socket.connected) this.socket.emit('approve', {tokenAddress: this.currentToken.adr.toString().replace(/ /g, ""), swapAddress: this.currentSwap.address.toString().replace(/ /g, "")})
            else this.PushNotify(" > Authentication is needed to do this action.")
          }
        }
      } catch(e) {

      }
    },
    startBalDelay() {
      if(this.balUpdateTimeout) clearTimeout(this.balUpdateTimeout);
      this.balUpdateTimeout = setTimeout(this.clearBalDelay, 12000);
    },
    clearBalDelay() {
      if(this.currentWallet) {
        this.currentWallet.balanceOverride = false;
      }
    },
    changeOrdersLog(history = true, running = false, market = false) {
      this.showOrdersHistory = history;
      this.showMarketOrders = market;
    },
    changeSnipeView() {
      this.showActiveSnipes = !this.showActiveSnipes;
    },
    autoOrderAction(uuid) {
      const action = this.getOrderAction(uuid);
      let res = {
        uuid: this.autoTrades[uuid].uuid,
        cancel: true
      }
      if(action == 'delete') {
        res.cancel = false;
      }
      if(this.socket.connected) this.socket.emit('changeLimitOrder', res);
      else this.PushNotify(" > Authentication is needed to do this action.")
    },
    blProtection(uuid) {
      if(this.socket.connected) this.socket.emit('changeBLProtection', this.autoTrades[uuid].uuid);
      else this.PushNotify(" > Authentication is needed to do this action.")
    },
    getOrderAction(uuid) {
      if(this.autoTrades[uuid].status == 'placing') return 'delete';
      if( this.autoTrades[uuid].status != 'canceled' &&
          !this.autoTrades[uuid].status.toLowerCase().includes('error') &&
          this.autoTrades[uuid].status != 'tx sent' &&
          this.autoTrades[uuid].status != 'timeout' &&
          this.autoTrades[uuid].status != 'success' &&
          this.autoTrades[uuid].status != 'reverted'
          ) {
            return 'cancel';
          } else if(this.autoTrades[uuid].status == 'canceled' ||
                    this.autoTrades[uuid].status == 'tx sent' ||
                    this.autoTrades[uuid].status.toLowerCase().includes('error') ||
                    this.autoTrades[uuid].status == 'success' ||
                    this.autoTrades[uuid].status == 'timeout' ||
                    this.autoTrades[uuid].status == 'reverted') {
                      return 'delete';
                    } else return '';
    },
    computeShowLimitButton(uuid) {
      if(this.autoTrades&&this.autoTrades[uuid].status != 'placing') return true;
      else return false;
    },
    timeConverter(UNIX_timestamp){
      const timestamp = UNIX_timestamp.toString().length == 13?UNIX_timestamp:UNIX_timestamp*1000;
      var a = new Date(timestamp);
      var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
      var year = a.getFullYear().toString().slice(-2);
      var month = months[a.getMonth()];
      var date = a.getDate();
      var hour = formatTime(a.getHours());
      var min = formatTime(a.getMinutes());
      var sec = formatTime(a.getSeconds());
      var time = date + '.' + month + '.' + year + ' ' + hour + ':' + min + ':' + sec ;
      function formatTime(t) {
        if(t < 10) t = '0'+t;
        return t;
      }
      return time;
    },
    computeShowBlacklistProtection(uuid) {
      if(this.autoTrades&&this.autoTrades[uuid].status != 'placing'&&!this.autoTrades[uuid].trade.settings.tech.chainID == 56) return true;
      else return false;
    },
    computeShowExecuteButton(uuid) {
      if(this.autoTrades&&this.autoTrades[uuid].status == 'running'&&!this.autoTrades[uuid].trade.settings.trade.launchBuy) return true;
      else return false;
    },
    isPositiveValue(val) {
      return parseFloat(val) >=0? true: false;
    },
    getBNBFromWei(val) {
      return this.getFloatWithDoublePrecision(parseFloat(Web3.utils.fromWei(val, 'ether')).toFixed(5),true) ;
    },
    switchPanelBuying() {
      this.isPanelBuyingNow = !this.isPanelBuyingNow;
      if(!this.isPanelBuyingNow) {
        if(this.chain&&this.chain.ID != 56) this.setEarlyApproval();
        this.useBP = false;
      }
      this.botSwapFocus = !this.botSwapFocus;
      this.swapHandler(true);
    },
    fillQuick(bal) {
      if(this.isPanelBuyingNow) {
        this.fillBalance(bal, true);
        this.amountHandler();
      }
      else {
        this.fillToken(bal, true);
        this.sellamountHandler();
      }
      this.botSwapFocus = false;
    },
    fillByScroll(bal) {
      if(this.isPanelBuyingNow) {
        this.fillBalance(bal);
        this.amountHandler();
      }
      else {
        this.fillToken(bal);
        this.sellamountHandler();
      }
      this.botSwapFocus = false;
    },
    getCurrentValues() {
      return this.currentValues;
    },
    setCurrentValues(vals) {
      this.currentValues = vals;
    },
    setLimits(val, tp) {
      if(tp) this.takeProfit = val;
      else this.stopLoss = val;
    }, 
    isDefaultSetting(setting, option = false) {
      switch(setting) {
        case 'gas':
          if(this.gasPreset == option) return true;
          else return false;
          break;
        case 'slippage':
          if(this.settingsSlippage == 25) return true;
          else return false;
          break;
      }
      return false;
    },
    setDefaultSetting(setting) {
      switch(setting) {
        case 'gas':
          this.setRangeSettings(200,0);
          this.currentValues[4] = this.settingsGas * 5;
          break;
        case 'slippage':
          this.setRangeSettings(25,1);
          this.currentValues[5] = this.settingsSlippage * 5;
          break;
      }
    },
    setGasPreset(val) {
      this.gasPreset = val === 'low' ||  val === 'medium' || val === 'high' ? val : 'medium';
      if(this.socket.connected) {
        this.socket.emit('updateSettings', {gasPreset: this.gasPreset, slippage: this.settingsSlippage})
        this.updateDataForCurrentBlock();
      }
      else this.PushNotify(" > Authentication is needed to do this action.")
    },
    setRangeSettings(val, index) {
      if(index == 0) this.settingsGas = val;
      if(index == 1) this.settingsSlippage = val;
      if(this.socket.connected) {
        this.socket.emit('updateSettings', {gasPreset: this.gasPreset, slippage: this.settingsSlippage})
        this.recalcRecommendedBal();
      }
      else this.PushNotify(" > Authentication is needed to do this action.")
    },
    setBuyingPrice(val) {
      try {
      this.buyingPriceMultiplyer = this.USDPrice*0.0004*val;
      this.priceTriggerAmount = this.getFloatWithDoublePrecision(Number(this.priceTriggerAmount)+this.buyingPriceMultiplyer);
      } catch(e) {

      }

    },
    changetSL() {
      this.tSL = !this.tSL;
    },
    changeTP(force = false) {
        this.useTP = !this.useTP;
       /* if(this.useTP) {
          if(this.isPanelBuyingNow&&!this.useBP) this.changeBP();
        }*/
        
    },
    changeBP(force = false) {
        this.useBP = !this.useBP;
        if(!this.isPanelBuyingNow&&this.useBP) this.switchPanelBuying()
        /*if(this.isPanelBuyingNow&&!this.useBP&&(this.useSL||this.useTP)) {
          this.useSL = false;
          this.useTP = false;
        }*/
    },
    changeMEV() {
        this.useMEV = this.showLogSection('snipe')?true:!this.useMEV;
        this.updateDataForCurrentBlock();
        this.recalcRecommendedBal();
    },
    changeDisableRetry() {
      this.disableRetry = !this.disableRetry;
    },
    changeSL(force = false) {
        this.useSL = !this.useSL;
      /*  if(this.useSL) {
          if(this.isPanelBuyingNow&&!this.useBP) this.changeBP();
        }*/
    },
    execute(uuid) {
      if(this.autoTrades&&this.autoTrades[uuid]) {
        if(this.socket.connected) this.socket.emit('forceExecute', this.autoTrades[uuid].uuid)
        else this.PushNotify(" > Authentication is needed to do this action.")
      }
    },
    setLimitOrderSlippage(uuid, positive) {
      if(this.autoTrades&&this.autoTrades[uuid]) {
        if(this.socket.connected) this.socket.emit('changeLimitOrderSettings', {uuid:this.autoTrades[uuid].uuid, positive:positive, setting: 'slippage', gasPreset: 'medium', disableRetry: this.disableRetry})
        else this.PushNotify(" > Authentication is needed to do this action.")
      }
    },
    setLimitOrderProtectons(uuid, protection, value) {
      if(this.autoTrades&&this.autoTrades[uuid]) {
        if(this.socket.connected) this.socket.emit('changeLimitOrderProtectons', {uuid:this.autoTrades[uuid].uuid, protection:protection, value: value})
        else this.PushNotify(" > Authentication is needed to do this action.")
      }
    },
    setLimitOrderGas(uuid, val) {
      if(this.autoTrades&&this.autoTrades[uuid]) {
        if(this.socket.connected) this.socket.emit('changeLimitOrderSettings', {uuid:this.autoTrades[uuid].uuid, positive:false, setting: 'gas', gasPreset: val, disableRetry: this.disableRetry})
        else this.PushNotify(" > Authentication is needed to do this action.")
      }
    },
    setLimitOrderRetry(uuid, val) {
      if(this.autoTrades&&this.autoTrades[uuid]) {
        if(this.socket.connected) this.socket.emit('changeLimitOrderSettings', {uuid:this.autoTrades[uuid].uuid, positive:false,setting: 'disableRetry', gasPreset: 'medium', disableRetry: val})
        else this.PushNotify(" > Authentication is needed to do this action.")
      }
    },
    addToFavorites() {
      if(this.currentToken&&this.chain) {
        let index = this.currentToken.adr.toLowerCase() + this.chain.ID.toString();
        if(this.socket.connected) this.socket.emit('changeFavorites', {address:this.currentToken.adr, smb:this.currentToken.smb4,
                                            del:this.favorites[index]?true:false,
                                            chain:this.chain.ID});
                                            else this.PushNotify(" > Authentication is needed to do this action.")
      }
    },
    tokenInFavoritesUsed(item) {
      if(this.currentToken&&item&&this.chain) {
        if(item.address.toLowerCase() == this.currentToken.adr.toLowerCase() && item.chain == this.chain.ID) return true;
      }
      return false;
    },
    isMevProtection(id){
      if(this.autoTrades&&this.autoTrades[id]&&this.autoTrades[id].trade.session&&this.autoTrades[id].trade.session.protections.mev) return true;
      else return false;
    },
    isblProtection(id){
      if(this.autoTrades&&this.autoTrades[id]&&this.autoTrades[id].trade.session&&this.autoTrades[id].trade.session.protections.mev) return true;
      else return false;
    },
    isBlacklisted(id){
      if(this.autoTrades&&this.autoTrades[id]&&this.autoTrades[id].tradingStatus&&this.autoTrades[id].tradingStatus.blProtectionTriggered) return true;
      else return false;
    },
    isChainSelected(chain) {
      if(this.chain.ID == chain) return true;
      else return false;
    },
    isChainSelected(chain) {
      if(this.chain.ID == chain) return true;
      else return false;
    },
    switchChain(chain) {
      if(chain == 56 || chain == 1 || chain == 11155111 || chain == 8453) {
        if(this.socket.connected) this.socket.emit('changeChain', chain);
        else this.PushNotify(" > Authentication is needed to do this action.")
      }
    },
    updateSwap(swap = false) {
      if(!swap) {
        const keys = Object.keys(this.chain.swaps);
        keys.forEach((name) => {
          if(this.chain.swaps[name].default) this.currentSwap = this.chain.swaps[name];
        });
      } else {
        this.currentSwap = swap;
      }
      this.currentSwap.ABI = ABIS[this.currentSwap.ABI];
      pcsContractVue = new web3Vue.eth.Contract(this.currentSwap.ABI);
      pcsContractVue.options.address = this.currentSwap.address;
      quoterWeb3.initialize(quoterContract, web3Vue, this.currentSwap);
      if(!quoterWeb3.isV3) {
        quoterContract = pcsContractVue;
      } else {
        quoterContract = new web3Vue.eth.Contract(ABIS[this.currentSwap.ABIQuoter]);
        quoterContract.options.address = this.currentSwap.quoter;
      }
      quoterWeb3.initialize(quoterContract, web3Vue, this.currentSwap);
    },
    getChain() {
      return this.chain;
    },
    isShowOptionsPopUp(addr) {
      if(this.currentWalletOptions == addr) return true;
      else return false;
    },
    showOptionsPopUp(addr) {
      this.currentWalletOptions = addr;
    },
    hideOptionsPopUp(e) {
      if(this.currentWalletOptions != 0) this.currentWalletOptions = 0;
    },
    hideRename() {
      if(this.walletsArray && this.walletsArray[this.currentRename]) {
        if(this.renameValue === "" && !this.walletsArray[this.currentRename].tag) {
            this.alertBlock("Wallet name has not been changed", 1000); 
       } else {
        if(this.walletsArray[this.currentRename].tag != this.renameValue) {
          if(this.socket.connected) this.socket.emit('changeWalletName', {index: this.currentRename, value: this.renameValue});
          else this.PushNotify(" > Authentication is needed to do this action.")
        } else {
          this.alertBlock("Wallet name has not been changed", 1000);
        }
       }
     
      }
      this.renameValue = "";
      this.currentRename = -1;
    },
    clearSecret() {
      this.secretWallets = null;
      this.swPage = null;
      this.secretWalletSelected = null;
    },
    changeSWPage(increase) {
        if(this.canChangeSWPage(increase)) this.swPage = increase?this.swPage+1:this.swPage-1;
    },
    changeHPage(increase) {
        if(this.canChangeHPage(increase)) this.hPage = increase?this.hPage+1:this.hPage-1;
    },
    canChangeSWPage(increase) {
      if(increase) {
        if(this.secretWallets.length >= ((this.swPage+1)*6+6)) return true;
        else return false;
      } else {
        if((this.swPage-1) >= 0) return true;
        else return false;
      }
    },
    canChangeHPage(increase) {
      if(increase) {
        if(this.ordersArray.length > ((this.hPage)*5+5)) return true;
        else return false;
      } else {
        if((this.hPage-1) >= 0) return true;
        else return false;
      }
    },
    selectSecretWallet(pk) {
      this.secretWalletSelected = pk;
    },
    importSecretWallet() {
      if(this.secretWalletSelected) {
        this.importWallet(this.secretWalletSelected)
      } else {
        const msg = 'There is no wallet selected for import. Click on the wallet to select it.';
        this.alertWallet(msg, 3000);
        const logsDiv = document.getElementById('logsMain')
        let txhash = null;
        this.logsArray.push("> "+msg)
        this.logsTxHasArray.push(txhash)
        this.logsClass.push(this.logsClassArray[2])
        this.resultArray.push(null)
        this.$nextTick(() => {
          if(logsDiv) logsDiv.scrollTop = logsDiv.scrollHeight
        })
      }
    },
    renameWallet(index) {
      this.currentRename = index;
      if(this.walletsArray && this.walletsArray[index]) {
        if(this.walletsArray[index].tag == this.renameValue) {
          this.renameValue = this.walletsArray[index].tag;
        }
      }
      this.renameKey +=1;
    },
    checkValue(val) {
      if((val === undefined || val === null)) {
        return true;
      }
      if(VALUECHECK.test(val.toString())) {
        return true;
      }
      return false; 
    },
    useUSDPrice() {
        this.priceTriggerAmount = this.getFloatWithDoublePrecision(this.USDPrice)
    },
    async updateDataForCurrentBlock() {
      if(this.walletsArray.length > 0) {
        const prevC = this.prevChain;
        try {
        let currTokBalForSelectedWalet = '0';
        let args = [];
        let tokBalCheck = false;
        let txCostCheck = false;
        let gasPrice = 0;
        let gasPriceMin = 0;
        if(this.currentToken) {
          if(this.currentBlockData.gas) {
            if(this.currentBlockData.gas.isLegacy) {
              gasPrice = this.currentBlockData.gas.current[this.gasPreset];
              gasPriceMin = gasPrice;
            } else {
              gasPrice = this.useMEV&&this.chain.ID != 56?this.currentBlockData.gas.mev[this.gasPreset].maxFeePerGas:this.currentBlockData.gas.current[this.gasPreset].maxFeePerGas;
              gasPriceMin = this.useMEV?this.currentBlockData.gas.baseGas + this.currentBlockData.gas.mev[this.gasPreset].maxPriorityFeePerGas:this.currentBlockData.gas.baseGas + this.currentBlockData.gas.current[this.gasPreset].maxPriorityFeePerGas;
            }
          } else {
            gasPrice = await web3Vue.eth.getGasPrice();
            gasPriceMin = gasPrice;
            gasPrice = (parseInt(gasPrice*1.2))
          }
          gasPriceMin = gasPriceMin*parseInt(this.currentToken.estAMT);
          gasPrice = gasPrice*parseInt(this.currentToken.estAMT);
        }
        this.walletsArray.forEach(item => {
          args.push(multicall.getEthBalance(item.address))        
        });
        if(this.secretWallets) {
          this.secretWallets.forEach(item => {
            args.push(multicall.getEthBalance(item.address));          
          });
        }
        if(this.currentToken && this.currentWallet) {
          tokBalCheck = true;
          args.push(tokenContract.methods.balanceOf(this.currentWallet.address));
        }
        if(this.currentToken) {
          let USDPath = quoterWeb3.isV3? this.chain.USDPAIRPACKED: this.chain.USDPAIR;
          args.push(quoterWeb3.getAmountsOutMethod(Web3.utils.toWei(gasPriceMin.toString(),'wei'), USDPath.path));
          args.push(quoterWeb3.getAmountsOutMethod(Web3.utils.toWei(gasPrice.toString(),'wei'), USDPath.path));
          txCostCheck = true;
        }
        if(args.length == 0) return;
        let aggregateResults = await multicall.aggregate(args);
        if(prevC == this.chain.ID) {
         for(let i = 0; i < this.walletsArray.length; i++) {
          this.updateWalletBalanceAtIndex(i, aggregateResults[i]); 
        }
        if(this.secretWallets) {
          for(let i = this.walletsArray.length; i < (this.walletsArray.length+this.secretWallets.length); i++) {
            this.updateSecretWalletBalanceAtIndex(i-this.walletsArray.length, aggregateResults[i]); 
          }
        }
        let tokBalIndex = tokBalCheck?(txCostCheck?aggregateResults.length-3:aggregateResults.length-1):null;
        if(txCostCheck) {
          let wethPrice = 0;
          let wethPriceMin = 0;
          if(!quoterWeb3.isV3) {
            wethPrice = aggregateResults[aggregateResults.length-1][1];
            wethPriceMin = aggregateResults[aggregateResults.length-2][1];
          } else {
            wethPrice = aggregateResults[aggregateResults.length-1];    
            wethPriceMin = aggregateResults[aggregateResults.length-2];
          }      
          let minCost = this.getFloatWithDoublePrecision(web3Vue.utils.fromWei(wethPriceMin.toString(),(!this.isBNB(this.chain.ID)?'mwei':'ether')).toString(), true, true, 3);
          let maxCost = this.getFloatWithDoublePrecision(web3Vue.utils.fromWei(wethPrice.toString(),(!this.isBNB(this.chain.ID)?'mwei':'ether')).toString(), true, true, 3);
          this.txCost = minCost == maxCost? (parseFloat(minCost).toFixed(3)+'$'):(parseFloat(minCost).toFixed(3)+'$'+' - '+parseFloat(maxCost).toFixed(3)+'$');
          this.recalcRecommendedBal();
       }
        this.updateTokenBalanceOfCurrentWallet(tokBalCheck?aggregateResults[tokBalIndex]:currTokBalForSelectedWalet);
        if(this.chain.ID != 56) this.setEarlyApproval()   
        }
        try {
            let cafeBSCWallet = await cafeContractBSC.methods.balanceOf(this.authWallet).call();
            let cafeBSCSelectedWallet = await cafeContractBSC.methods.balanceOf(this.currentWallet.address).call();
            let cafeBSCStaking = '0';
            let cafeETHWallet = await cafeContractETH.methods.balanceOf(this.authWallet).call();
            let cafeETHSelectedWallet = await cafeContractETH.methods.balanceOf(this.currentWallet.address).call();
            let cafeETHStaking = '0';
            try {
              cafeBSCStaking = await stakingContractBSC.methods.poolInfo(this.authWallet).call();
            cafeBSCStaking = cafeBSCStaking.amount;
            } catch(e) {
            }
            try {
              cafeETHStaking = await stakingContractETH.methods.poolInfo(this.authWallet).call();
              cafeETHStaking = cafeETHStaking.amount;
            } catch(e) {
            }
            if(!cafeETHStaking) cafeETHStaking = '0';
            if(!cafeBSCStaking) cafeBSCStaking = '0';
            this.cafe = {
              BSC: (parseFloat(Web3.utils.fromWei(cafeBSCWallet,'gwei')) + parseFloat(Web3.utils.fromWei(cafeBSCStaking,'gwei'))).toFixed(0),
              ETH: (parseFloat(Web3.utils.fromWei(cafeETHWallet,'gwei')) + parseFloat(Web3.utils.fromWei(cafeETHStaking,'gwei'))).toFixed(0),
              BSCWALLET: (parseFloat(Web3.utils.fromWei(cafeBSCSelectedWallet,'gwei'))),
              ETHWALLET: (parseFloat(Web3.utils.fromWei(cafeETHSelectedWallet,'gwei')))
            }
          } catch(e) {
          }
        } catch(e) {
        }
      }
    },
    exportKey(index) {
      if(this.socket.connected) this.socket.emit('exportKey',index)
      else this.PushNotify(" > Authentication is needed to do this action.")
    },
    subscribe() {
      if(this.socket.connected) this.socket.emit('subscribe', this.user.tier.subscribe?false:true);
      else this.PushNotify(" > Authentication is needed to do this action.")
    },
    clearDecodedKey(index) {
      try {
        if(this.walletsArray&&this.walletsArray[index]) this.walletsArray[index].decodedKey = null;
      }catch(e) {
      } 
    }
  },
  created () {
    this.socket.on('disconnect', () => {
      this.PushNotify(" > Disconnected from the server.")
      this.walletsArray = []
      this.withdrawalsArray=[];
      this.deletedWalletsExists = false;
      this.currentWallet = null;
      
      this.clearSecret();
      this.USDPrice = 0;
      this.MCAP = 0;
      this.LP = 0;
      this.useUSDPrice();
      this.ordersArray = [];
      this.autoTrades = {}
      this.marketTrades = {};
      this.connected = false;
      this.hPage = null;
    }),
    this.socket.on('connect', () => {
      this.connected = true;
      this.socket.emit('restoreSession', VERSION);
      this.socket.emit('getStatus')
    }),
    this.socket.on('connect_error', (err) => {
      if(err) {
        if(err.toString().includes('too many requests')) {
          this.PushErr(err.toString())
          Disconnect();
        } else {
          this.connected = false;
          this.PushErr("Failed to connect to data server. Retrying...")
        }
      }
    }),
    this.socket.on('forceDisconnect', () => {
      this.disconnect();
    }),
    this.socket.on('blocked', (ms) => {
      this.PushErr(" > Too much requests. Temporary restricted for " + (parseInt(ms)/1000 || 1).toString() +" seconds.")
    }),
    this.socket.on('onChainChanged', (data) => {
      const previousID = this.chain.ID;
      this.chain = data;
      prov = new Web3.providers.HttpProvider(this.chain.RPC);
      web3Vue = new Web3(new Web3.providers.HttpProvider(this.chain.RPC));
      this.txCost = 0;
      this.minBalToSend = 0;
      multicall = new Multicall({
        chainId: this.chain.ID,
        provider: prov
      });
      if(previousID != this.chain.ID) {
        this.prevChain = this.chain.ID;
        this.approved = false;
        this.currentToken = null;
        this.sellamount = '0'
        this.amount = '0'
        this.updateSwap();
        this.USDPrice = 0;
        this.MCAP = 0;
        this.LP = 0;
        this.useUSDPrice();
      }
    })
    this.socket.on('onKeyExported', (data) => {
      this.walletsArray[data.index].decodedKey = data.key;
      setTimeout(this.clearDecodedKey, 5000, data.index);
      this.alertWallet('Private key recieved. You have 5 seconds to copy.', 5000);
    }),
    this.socket.on('log', (data) => {
      this.logsArray.push(data)
      this.logsTxHasArray.push(null)
      this.logsClass.push(this.logsClassArray[0])
      this.resultArray.push(null)
      const logsDiv = document.getElementById('logsMain')
      this.$nextTick(() => {
        if(logsDiv) logsDiv.scrollTop = logsDiv.scrollHeight
      })
    })
    this.socket.on('logSpecial', ({msg, cls}) => {
      const logsDiv = document.getElementById('logsMain')
      let txhash = null;
      if(cls==3) { //error(for tx hash)
       if(msg.includes('Transaction hash:')) {
          txhash = msg.substring(msg.indexOf('Transaction hash:')+18, msg.length-1);
          msg = msg.substring(0, msg.indexOf('Transaction hash:')+18);
        }
      }
      this.logsArray.push(msg)
      this.logsTxHasArray.push(txhash)
      this.logsClass.push(this.logsClassArray[cls])
      this.resultArray.push(null)
      this.$nextTick(() => {
        if(logsDiv) logsDiv.scrollTop = logsDiv.scrollHeight
      })
    })
    this.socket.on('checkBot', (data) => {
      this.botOn = data
    })
    this.socket.on('onBlockUpdate', (data) => {
      this.block = data.block;
      this.currentBlockData = data;
      if(this.currentToken) {
        this.swapHandler();
        this.updateUSDPrice();
      }
      if(this.connected) {
        this.updateDataForCurrentBlock();
      }
    })
    this.socket.on('onSettingsUpdate', (data) => {
      this.gasPreset = data.gasPreset;
      this.settingsSlippage = data.slippage;
      this.currentValues[5] = this.settingsSlippage * 5;
      this.recalcRecommendedBal();
    })
    this.socket.on('onWithdrawalsUpdate', (data) => {
      this.withdrawalsArray = data;

      this.updateDataForCurrentBlock();
    })
    this.socket.on('onWalletsUpdate', (data) => {
      this.walletsArray = data;
      for(let i = 0; i < data.length; i++) {
        if(data[i].deleted) {
          this.deletedWalletsExists = true;
        }
        if(data[i].used) {
          this.currentWallet = null;
          this.currentWallet = data[i];
          this.currentWallet.balanceOverride = false;
          if(this.balUpdateTimeout) clearTimeout(this.balUpdateTimeout);
          this.setEarlyApproval();
        }
      }
      this.updateDataForCurrentBlock();
    })
    this.socket.on('onSecretPhraseDecoded', (data) => {
      this.secretWallets = data;
      this.swPage = 0;
      this.secretWalletSelected = null;
    })
    this.socket.on('onBlockAlert', (data) => {
      this.alertBlock(data, 1000);
    })
    this.socket.on('onWalletAlert', (data) => {
      this.alertWallet(data, 3000);
      const logsDiv = document.getElementById('logsMain')
      let txhash = null;
      this.logsArray.push("> "+data)
      this.logsTxHasArray.push(txhash)
      this.logsClass.push(this.logsClassArray[2])
      this.resultArray.push(null)
      this.$nextTick(() => {
        if(logsDiv) logsDiv.scrollTop = logsDiv.scrollHeight
      })
    })
    this.socket.on('onUserUpdate', (user) => {
      if(user) {
        this.user = user;
        this.usrReRenderer += 1;
      }
    })
    this.socket.on('onReferralUpdate', (data) => {
      if(data) {
        this.referralData = data;
      }
    })
    this.socket.on('onFreeUpgradeAvailable', (data) => {
      if(data) {
        this.freeUpgradeAvailable = data;
      }
    })
    this.socket.on('onEligibleForTaxesUpgrade', (data) => {
      this.eligibleData = data;
    })
    this.socket.on('onTierUpgrade', (user) => {
      if(user) {
        this.user = user;
        this.usrReRenderer += 1;
      }
      this.PushNotify("Your tier was upgraded to PRO! Your monthly subscription was enabled. You can disable it under profile window.")
    })
    this.socket.on('onGetStatus', (data) => {
      if(data) {
        if(data.maintenance) {
          this.maintenance = true;
        } else {
          this.maintenance = false;
        }
      } else {
        this.maintenance = false;
      }

    })
     this.socket.on('onSearch', (data) => {
      this.searchInProgress = true;
     })
     this.socket.on('onSearchExit', (data) => {
      this.searchInProgress = false;
     })
    this.socket.on('onSearchSuccess', (data) => {
      if(data.tradable) {
        if(this.currentToken) {
          if(this.currentToken.adr != data.adr) {
            this.reRenderChart +=1;
            this.USDPrice = 0;
            this.MCAP = 0;
            this.LP = 0;
            this.useUSDPrice();
          }
        }
        this.currentToken = null;
        this.currentToken = data;
        this.currentWallet.tokenBalance = '0';
        this.sellamount = '0'
        this.amount = this.amount;
        this.currentToken.smb4 = this.currentToken.smb.substring(0,4);
        this.currentToken.smb3 = this.currentToken.smb.substring(0,3);
        this.updateSwap(this.currentToken.swap);
        tokenContract = new web3Vue.eth.Contract(ABIS["ERC20"]);
        tokenContract.options.address = this.currentToken.adr;
        WETHcontract = new web3Vue.eth.Contract(ABIS["ERC20"]);
        WETHcontract.options.address = this.currentToken.pth[this.currentToken.pth.length-2];
        if(data.apprv) this.logsArray.push("Ready to trade.")
        else {
          if(this.chain.ID == 56) this.logsArray.push("Ready to buy. Attempting to auto-approve...")
          else this.logsArray.push("Ready to buy. Manual approve before sell is required.")
        }
        this.logsTxHasArray.push(null)
        this.logsClass.push('log-b');
        this.resultArray.push(null)
        const logsDiv = document.getElementById('logsMain')
        if(this.socket.connected) this.socket.emit('fetchBalance', this.currentToken.adr);
        else this.PushNotify(" > Authentication is needed to do this action.")
        this.swapHandler();
        this.updateUSDPrice();
        if(this.chain.ID !=56) this.setEarlyApproval();
        this.updateDataForCurrentBlock();
        this.$nextTick(() => {
        if(logsDiv) logsDiv.scrollTop = logsDiv.scrollHeight
      })
      } else {
        let index = (data.adr.toLowerCase() + this.chain.ID.toString());
        if(this.favorites[index]) {
          if(this.socket.connected) this.socket.emit('changeFavorites', {address:data.adr, smb:data.smb.substring(0,4),
                                                del: true,
                                                chain:this.favorites[index].chain});
                                                else this.PushNotify(" > Authentication is needed to do this action.")
        }
      }
    })
    this.socket.on('onTradeSuccess', (data) => {
      if(this.currentToken&& data.settings.token.address.toLowerCase() == this.currentToken.adr.toLowerCase()) {
        if(this.socket.connected) this.socket.emit('fetchBalance', this.currentToken.adr);
        else this.PushNotify(" > Authentication is needed to do this action.")
      }
      //if(!data.sell) data.outH = this.fromBNtoString(data.out);
      /*this.quickWarn = data;
      this.quickWarn.inH = parseFloat(this.quickWarn.inH.toString()).toFixed(this.decimalCount(this.quickWarn.inH.toString())>6?6:this.decimalCount(this.quickWarn.inH.toString()));
      this.quickWarn.outH = parseFloat(this.quickWarn.outH.toString()).toFixed(this.decimalCount(this.quickWarn.outH.toString())>6?6:this.decimalCount(this.quickWarn.outH.toString()));
      if(this.quickWarnTimeout) clearTimeout(this.quickWarnTimeout);
      this.quickWarnTimeout = setTimeout(() => {this.quickWarn = null}, 3000)*/
        this.logsArray.push("")
        this.logsTxHasArray.push(null)
        this.logsClass.push(this.logsClassArray[0])
        this.resultArray.push(data)
        const logsDiv = document.getElementById('logsMain')
        this.$nextTick(() => {
        if(logsDiv) logsDiv.scrollTop = logsDiv.scrollHeight
      })
    })
    this.socket.on('onOrdersUpdate', (data) => {
      if(data.trades != null) this.ordersArray = data.trades.reverse();
      else this.ordersArray = [];
      if(data.autoTrades != null) {
        Object.keys(data.autoTrades).forEach(key => {
           if(data.autoTrades[key].trade.session) data.autoTrades[key].trade.session.currentPrice = Web3.utils.toBN(data.autoTrades[key].trade.session.currentPrice).toString();
        });
        this.autoTrades = data.autoTrades;
      }
      else this.autoTrades = {};
      this.atRerenderer +=1;
    })
    this.socket.on('onAutoTradeUpdate', (data) => {
      if(this.autoTrades != null) {
        if(!data.autoTrade && this.autoTrades[data.uuid]) delete this.autoTrades[data.uuid];
        else if(data.autoTrade) {
          this.autoTrades[data.uuid] = data.autoTrade;
        }
      }
      else {
        this.autoTrades = {}; 
      }
      if(this.autoTrades[data.uuid]&&this.autoTrades[data.uuid].trade.session) {
        this.autoTrades[data.uuid].trade.session.currentPrice = Web3.utils.toBN(this.autoTrades[data.uuid].trade.session.currentPrice).toString();
      }
      this.atRerenderer += 1;
    })
    this.socket.on('onMarketTradeStatusUpdate', (data) => {
      if(this.marketTrades != null) {
        if(!data && this.marketTrades[data.uuid]) delete this.marketTrades[data.uuid];
        else if(data) {
          if(!this.marketTrades[data.uuid]) {
            this.marketTrades[data.uuid] = data;
            this.logsArray.push("")
            this.logsTxHasArray.push(null)
            this.logsClass.push(this.logsClassArray[0])
            let index = (this.resultArray.push(this.marketTrades[data.uuid]) - 1);
            this.marketTrades[data.uuid].index = index;
            const logsDiv = document.getElementById('logsMain')
            this.$nextTick(() => {
            if(logsDiv) logsDiv.scrollTop = logsDiv.scrollHeight});
          } else {
            data.index = this.marketTrades[data.uuid].index;
            this.marketTrades[data.uuid] = data; 
            this.resultArray[this.marketTrades[data.uuid].index] = this.marketTrades[data.uuid];
          }
        }
      }
      else {
        this.marketTrades = {}; 
      }
      this.mtRerenderer += 1;
    })
    this.socket.on('onFetchBalance', (data) => {
      this.currentWallet.balance = this.fromBNtoBNB(data.wBalance);
      this.currentWallet.tokenBalance = data.tBalance;
      this.reRender +=1;
      this.currentWallet.balanceOverride = true;
      this.startBalDelay();
    })
    this.socket.on('onFavoritesUpdate', (data) => {
      this.favorites = data;
    })
  }
}
</script>

<style>

</style>